import { useCallback, useEffect, useRef, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { InputFieldset } from "ui/inputFieldset";
import { SelectFieldset } from "ui/selectFieldset";
import { TextareaUI } from "ui/textareaUI";
import { CheckboxFieldset } from "ui/checkboxFieldset";
import { Label } from "../../ui/label";
import { Badge } from "../../ui/badge";
// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { Checkbox } from "../../ui/checkbox";
import { Alert, AlertDescription } from "../../ui/alert";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../components/ui/popover";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
} from "../../components/ui/command";
import {
  CheckCircle2,
  XCircle,
  Upload,
  FileText,
  User,
  MapPin,
  AlertCircle,
  Plus,
  ShieldCheck,
  Trash2,
  Users,
  ChevronDown,
  ChevronUp,
  History,
  Eye,
  Loader2,
  Check,
  ChevronsUpDown,
  TriangleAlert,
} from "lucide-react";
// import {
//   Dialog,
//   DialogContent,
//   DialogDescription,
//   DialogFooter,
//   DialogHeader,
//   DialogTitle,
// } from '../../ui/dialog';
import { toast } from "sonner";
import { cn } from "../../ui/utils";
import {
  AddNewPartners,
  AddAreaOfOpertaion,
  ApprovedTourOperator,
  checkOfficeNameAvailability,
  Country,
  deleteAreaOfOperation,
  deletePartners,
  getCountryCity,
  getRegistrationDetails,
  rejectTourOperator,
  reUploadPartnersDocuments,
  reUploadTourDocuments,
  updateTourOperatorRegistration,
} from "../../services/newRegistrationService";
import { FullScreenLoading } from "../../components/ui/loader";
import AddNewPartnerPopup from "./AddNewPartnerPopup";
// import { AreaOfOperation, ConfigErrors, DocumentHistory, DocumentHistoryNew, DocumentUpload, Partner, PartnerFormErrors, TORegistration, TourOperatorTypeObj } from '../../types/tourOperator';
import {
  AreaOfOperation,
  DocumentUpload,
  Partner,
  PartnerFormErrors,
  TORegistration,
} from "../../types/tourOperator";
// import { AreaOfOperation, DocumentUpload, Partner, PartnerFormErrors, TORegistration, TourOperatorTypeObj } from '../../types/tourOperator';
import ConfirmDialog from "../../ui/ConfirmDialog";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import {
  formatFileSizeFromKB,
  formatUploadedDateTime,
  getFileViewUrl,
  validatePhoneNumberInput,
} from "../../utils/commonutils";
import {
  DocumentApiResponse,
  getScreenDocuments,
} from "../../services/documentService";
import { useScreenPermission } from "../../hooks/useScreenPermission";
import { usePageHeader } from "contexts/PageHeaderContext";
import useDebounce from "../../hooks/useDebounce";
import { useAuth } from "../../contexts/AuthContext";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../ui/tooltip";

// interface PartnerConfiguration {
//   partnerId: string;
//   permissionDate: string;
//   toType: string;
//   isInclusive: boolean;
//   permanentDiscount: string;
//   isRequiredForPublic: boolean;
// }

interface PartnerForm {
  id: string;
  isNonItsPartner: boolean;
  itsNumber: string;
  name: string;
  fullName: string;
  fatherName: string;
  email: string;
  mobileNumber: string;
  dateOfBirth: string;
  address: string;
  role: string;
  isPartner: boolean;
  isOfficeStaff: boolean;
  loginRequired: boolean;
  isAuthorizedGroupLeader: boolean;
  documents: DocumentUpload[];
  addedAfterApproval?: boolean;
  acceptedFormats?: string;
  maxFileSizeKB?: number;
}

const mergeDocumentRequirements = (
  requirements: DocumentUpload[],
  uploadedDocuments: DocumentUpload[],
): DocumentUpload[] => {
  if (requirements.length === 0) return uploadedDocuments;

  const merged = requirements.map((requirement) => {
    const uploaded = uploadedDocuments.find(
      (document) =>
        String(document.documentMasterId || document.id) === requirement.id,
    );

    return {
      ...uploaded,
      ...requirement,
      documentId: uploaded?.documentId,
      documentMasterId: requirement.id,
      file: uploaded?.file ?? null,
      status: uploaded?.status ?? "",
      uploadedUrl: uploaded?.uploadedUrl,
      history: uploaded?.history ?? [],
      versions: uploaded?.versions ?? [],
    };
  });

  const knownMasterIds = new Set(requirements.map((document) => document.id));
  const legacyDocuments = uploadedDocuments
    .filter(
      (document) =>
        !knownMasterIds.has(String(document.documentMasterId || document.id)),
    )
    .map((document) => ({
      ...document,
      id: String(document.documentMasterId || document.id),
    }));

  return [...merged, ...legacyDocuments];
};

interface AreaToDelete {
  areaId: string;
  tourOperatorId: string;
}

interface TORegistrationAdminPageProps {
  onNavigate?: (page: string) => void;
}

interface SearchableSelectOption {
  label: string;
  value: string;
}

const EMAIL_PATTERN =
  /^[A-Za-z0-9](?:[A-Za-z0-9._%+-]*[A-Za-z0-9])?@[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z]{2,})+$/;

const SearchableSelectFieldset = ({
  label,
  value,
  options,
  placeholder,
  searchPlaceholder,
  error,
  disabled,
  onChange,
}: {
  label: string;
  value: string;
  options: SearchableSelectOption[];
  placeholder: string;
  searchPlaceholder: string;
  error?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
}) => {
  const [open, setOpen] = useState(false);
  const selectedOption = options.find((option) => option.value === value);

  return (
    <div className="space-y-1">
      <fieldset
        className={cn(
          "w-full rounded-[0.6rem] border-0 bg-transparent px-3 pb-2 pt-1 shadow-[inset_0_0_0_1px_rgba(0,0,0,0.1)] transition-all focus-within:shadow-[inset_0_0_0_1px_rgba(59,130,246,0.6),0_0_0_3px_rgba(59,130,246,0.25)]",
          disabled && "cursor-not-allowed !bg-gray-100",
        )}
      >
        <legend
          className={cn("mb-1 bg-white px-1", disabled && "!bg-gray-100")}
        >
          <span className="text-sm font-medium text-gray-700">{label}</span>
          <span className="ml-1 text-red-500">*</span>
        </legend>
        <div className="relative h-6">
          <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
              <Button
                type="button"
                variant="outline"
                role="combobox"
                aria-expanded={open}
                disabled={disabled}
                className={cn(
                  "absolute inset-0 h-6 min-h-0 w-full justify-between border-0 bg-transparent p-0 text-sm font-normal leading-none shadow-none hover:bg-transparent",
                  !selectedOption && "text-gray-500",
                )}
              >
                <span className="truncate">
                  {selectedOption?.label || placeholder}
                </span>
                <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
              </Button>
            </PopoverTrigger>
            <PopoverContent
              className="w-[--radix-popover-trigger-width] p-0"
              align="start"
            >
              <Command>
                <CommandInput
                  placeholder={searchPlaceholder}
                  className="!border-0 !outline-none !ring-0 !shadow-none focus:!border-0 focus:!outline-none focus:!ring-0 focus:!shadow-none focus-visible:!border-0 focus-visible:!outline-none focus-visible:!ring-0 focus-visible:!shadow-none"
                />
                <CommandEmpty>No option found.</CommandEmpty>
                <CommandGroup className="max-h-64 overflow-y-auto">
                  {options.map((option) => (
                    <CommandItem
                      key={option.value}
                      value={option.label}
                      onSelect={() => {
                        onChange(option.value);
                        setOpen(false);
                      }}
                    >
                      {option.label}
                      <Check
                        className={cn(
                          "ml-auto h-4 w-4",
                          value === option.value ? "opacity-100" : "opacity-0",
                        )}
                      />
                    </CommandItem>
                  ))}
                </CommandGroup>
              </Command>
            </PopoverContent>
          </Popover>
        </div>
      </fieldset>
      {error && <p className="text-xs text-red-500">{error}</p>}
    </div>
  );
};

// interface MisalDocumentUpload {
//   id: string;
//   name: string;
//   file: File | null;
//   isRequired: boolean;
//   country?: string;
//   acceptedFormatsList: string[]; // ✅ array of formats
//   maxFileSizeKB?: number;
//   maxFileSizeMB?: number;
//   history?: DocumentHistory[];
//   versions?: DocumentHistoryNew[];
//   uploadedUrl?: string
// }

export const MyRegistrationReviewPage = ({
  onNavigate,
}: TORegistrationAdminPageProps) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { setPageHeader } = usePageHeader();
  const params = useParams<{ id: string }>();
  const [selectedRegistration, setSelectedRegistration] = useState<TORegistration | null>(null);
  // const pendingPartnerApprovalCount = selectedRegistration?.pendingPartnerApprovalCount ?? 0;
  const [isAreaDeleteOpen, setIsAreaDeleteOpen] = useState(false);
  const [areaToDelete, setAreaToDelete] = useState<AreaToDelete | null>(null);
  const [AddpartnerErrors, setAddPartnerErrors] = useState<PartnerFormErrors>(
    {},
  );
  // const [errors, setErrors] = useState<AreaErrors>({});
  const [activeTab] = useState<
    "pending" | "approved" | "rejected" | "Rejected"
  >("pending");
  const [rejectReason, setRejectReason] = useState("");
  const [showUploadDialog, setShowUploadDialog] = useState(false);
  const [rejectedDoc, setRejectedDoc] = useState<DocumentUpload | null>(null);
  const [reUploadFiles, setReuploadFiles] = useState<File[]>([]);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [refetchApi, setRefetchApi] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  // Check if current user is super admin
  // const currentUserEmail = localStorage.getItem('currentUserEmail') || 'admin@fhims.com';

  // const storedUser = localStorage.getItem("fhims_auth_user");
  // const currentUser = storedUser ? JSON.parse(storedUser) : null;
  // const isSuperAdmin = currentUser?.email === 'superadmin@fhims.com' || currentUser?.email === 'himisha.m@myosys.us';

  // Document history expansion state
  const [expandedDocHistory, setExpandedDocHistory] = useState<
    Record<string, boolean>
  >({});
  // const [expandedMisalHistory, setExpandedMisalHistory] = useState(false);
  const [expandedPartnerDocHistory, setExpandedPartnerDocHistory] = useState<
    Record<string, boolean>
  >({});
  const [loading, setLoading] = useState(false);

  // Form states - ITS Data (all editable except ITS number)
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [arabicName, setArabicName] = useState("");
  const [gender, setGender] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");

  // Additional Information
  const [whatsappUsername, setWhatsappUsername] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [alternateMobile, setAlternateMobile] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [isOfficeNameAvailable, setIsOfficeNameAvailable] = useState<
    boolean | null
  >(null);
  const officeNameValidationRequestRef = useRef(0);
  const debouncedOfficeName = useDebounce(officeName.trim(), 200);
  const [officeNumber, setOfficeNumber] = useState("");
  const [businessType, setBusinessType] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [permanentAddress, setPermanentAddress] = useState("");
  const [areasOfOperation, setAreasOfOperation] = useState<AreaOfOperation[]>(
    [],
  );
  const [currentArea, setCurrentArea] = useState<AreaOfOperation>({
    id: "",
    country: "",
    city: "",
    otherCity: "",
    address: "",
    contactNumber: "",
    countryId: "",
    cityId: "",
    tourOperatorId: "",
    areaId: 0,
  });
  const [isAuthorizedGroupLead, setIsAuthorizedGroupLead] = useState(false);
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const [documents, setDocuments] = useState<DocumentUpload[]>([]);
  const [documentRequirements, setDocumentRequirements] = useState<
    DocumentUpload[]
  >([]);
  const [countriesList, setCountriesList] = useState<Country[]>([]);
  // const [TourOperatorList, setTourOperatorList] = useState<TourOperatorTypeObj[]>([]);

  // Admin Configuration Fields
  // const [permissionDate, setPermissionDate] = useState('');
  // const [toType, setToType] = useState('');
  // const [isInclusive, setIsInclusive] = useState(false);
  // const [permanentDiscount, setPermanentDiscount] = useState('');
  // const [isRequiredForPublic, setIsRequiredForPublic] = useState(false);
  // const [configErrors, setConfigErrors] = useState<ConfigErrors>({});

  // const [misalMubarak, setMisalMubarak] = useState<File | null>(null);

  // Partner-wise configuration
  // const [partnerConfigurations, setPartnerConfigurations] = useState<PartnerConfiguration[]>([]);
  // const [selectedPartnerForConfig, setSelectedPartnerForConfig] = useState<Partner | null>(null);

  // Document deletion
  // const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  // const [documentToDelete, setDocumentToDelete] = useState<string | null>(null);
  // const [deleteRemark, setDeleteRemark] = useState('');

  // Partner document deletion
  // const [isPartnerDocDeleteOpen, setIsPartnerDocDeleteOpen] = useState(false);
  // const [partnerDocToDelete, setPartnerDocToDelete] = useState<{ partnerId: string; docId: string } | null>(null);
  // const [partnerDocDeleteRemark, setPartnerDocDeleteRemark] = useState('');

  // Partner editing state
  // const [editingPartner, setEditingPartner] = useState<Partner | null>(null);
  const [partners, setPartners] = useState<Partner[]>([]);

  // Partner removal
  const [isPartnerRemoveDialogOpen, setIsPartnerRemoveDialogOpen] =
    useState(false);
  const [partnerToRemove, setPartnerToRemove] = useState<Partner | null>(null);
  const [isPartnerDialogOpen, setIsPartnerDialogOpen] = useState(false);
  const [partnerFormData, setPartnerFormData] = useState<PartnerForm>({
    id: "",
    isNonItsPartner: false,
    itsNumber: "",
    name: "",
    fullName: "",
    fatherName: "",
    email: "",
    mobileNumber: "",
    dateOfBirth: "",
    address: "",
    role: "",
    isPartner: false,
    isOfficeStaff: false,
    loginRequired: false,
    isAuthorizedGroupLeader: false,
    documents: [],
    // documents: partnerDocumentRequirements.map(doc => ({
    //   id: doc.id,
    //   name: doc.name,
    //   status: doc.status,
    //   file: null,
    //   isRequired: doc.isRequired,
    // })),
    addedAfterApproval: false,
  });
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [isAddingArea, setIsAddingArea] = useState(false);
  // const [misaldocuments, setMisalDocuments] = useState<MisalDocumentUpload[]>([]);
  // const [showMisalHistory, setShowMisalHistory] = useState<MisalDocumentUpload[]>([]);

  const { canAdd, canDelete, canApprove } = useScreenPermission();

  //  FETCH COUNTRY & CITY & DOCUMENT
  // const fetchMisalDocuments = useCallback(
  //   async (screenName: string): Promise<MisalDocumentUpload[]> => {
  //     const response = await getScreenDocuments(screenName);
  //     if (!response) return [];
  //     return response.map((doc: DocumentApiResponse) => ({
  //       id: String(doc.documentId),
  //       name: doc.documentName,
  //       file: null,
  //       isRequired: doc.isMandatory,
  //       acceptedFormatsList: doc.acceptedFormatsList || [], // ✅ correct key
  //       maxFileSizeKB: doc?.maxFileSizeKB,
  //       maxFileSizeMB: doc?.maxFileSizeMB,
  //       history: [],
  //       versions: []
  //     }));
  //   }, []);

  const fetchCountryCity = useCallback(async () => {
    try {
      const result = await getCountryCity();
      if (!result) {
        return;
      }
      setCountriesList(result);
    } catch (error) {
      console.error("Failed to load documents");
    }
  }, []);

  const fetchDocumentRequirements = useCallback(async () => {
    const response = await getScreenDocuments("tour_operator_registration");
    if (!response) {
      toast.error("Failed to load required documents");
      return;
    }

    setDocumentRequirements(
      response.map((document: DocumentApiResponse) => ({
        id: String(document.documentId),
        documentMasterId: String(document.documentId),
        name: document.documentName,
        status: "",
        file: null,
        isRequired: document.isMandatory,
        acceptedFormatsList: document.acceptedFormatsList ?? [],
        acceptedFormats: (document.acceptedFormatsList ?? []).join(", "),
        maxFileSizeKB: document.maxFileSizeKB,
        history: [],
        versions: [],
      })),
    );
  }, []);

  //  FETCH COUNTRY & CITY & DOCUMENT
  // const fetchTourOperatorType = useCallback(async () => {
  //   try {
  //     const result = await TourOperatorType();
  //     if (!result) {
  //       return;
  //     }
  //     setTourOperatorList(result)
  //   } catch (error) {
  //     console.error("Failed to load tour operator type");
  //   }
  // }, [])

  useEffect(() => {
    setPageHeader({
      title: "Edit Tour Operator Registration",
      icon: <FileText className="h-4 w-4" />,
      onBack: () => navigate("/my-registration"),
    });

    return () => setPageHeader(null);
  }, [navigate, setPageHeader]);

  useEffect(() => {
    fetchCountryCity();
    fetchDocumentRequirements();
    // fetchTourOperatorType()
    // fetchMisalDocuments("TO_Registration_Approval").then((docs) => {
    //   setMisalDocuments(docs);
    // });
  }, [fetchCountryCity, fetchDocumentRequirements]);
  // }, [fetchCountryCity, fetchTourOperatorType,fetchMisalDocuments]);

  const fetchRegistrationDetails = useCallback(async () => {
    if (!params?.id) return;
    try {
      setLoading(true);
      const res = await getRegistrationDetails(params?.id);
      if (!res) {
        toast.error("No registration details found");
        return;
      }
      setSelectedRegistration(res);
    } catch (error) {
      toast.error("Failed to fetch registration details");
    } finally {
      setLoading(false);
    }
  }, [params?.id]);

  useEffect(() => {
    fetchRegistrationDetails();
  }, [fetchRegistrationDetails, params?.id, refetchApi]);

  useEffect(() => {
    if (!selectedRegistration) return;
    const registration = selectedRegistration;
    setFirstName(registration.firstName);
    setMiddleName(registration.middleName);
    setLastName(registration.lastName);
    setArabicName(registration.arabicName);
    setGender(registration.gender === "male" ? "Male" : "Female");
    setDateOfBirth(registration.dateOfBirth.split("T")[0]);

    setWhatsappUsername(registration.whatsAppUsername || "");
    // setMobileNumber(registration.mobile);
    setMobileNumber(registration.mobileNumber);
    setAlternateMobile(registration.alternateMobile || "");
    setOfficeName(registration.officeName);
    setOfficeNumber(registration.officeNumber);
    const normalizedBusinessType = registration.businessType
      ?.toLowerCase()
      .replace(/\s+/g, "_");
    setBusinessType(
      normalizedBusinessType === "sole_proprietorship"
        ? "sole_proprietor"
        : normalizedBusinessType || "",
    );
    setCountry(String(registration.countryId || ""));
    setCity(
      registration.city ||
        registration.otherCity ||
        String(registration.cityId || ""),
    );
    setPermanentAddress(registration.permanentAddress);
    setAreasOfOperation(registration.areasOfOperation);
    setIsAuthorizedGroupLead(
      registration.isAuthorizedGroupLeader ||
        registration.isAuthorizedGroupLead,
    );

    const uploadedDocuments: DocumentUpload[] =
      selectedRegistration.documents
        ?.filter((doc) => doc.moduleCode === "TO_REG")
        ?.map((doc) => {
          const latestVersion = doc.versions?.[0];
          const allHistories =
            doc.versions?.flatMap((version) => version.histories || []) || [];
          return {
            id: String(doc.documentMasterId ?? doc.documentId ?? ""),
            documentId: String(doc.documentId ?? ""),
            documentMasterId: String(doc.documentMasterId ?? ""),
            name: doc.documentName ?? "",
            status: doc.status ?? "",
            isRequired: Boolean(doc.isMandatory),
            versions: doc.versions,
            uploadedUrl: latestVersion?.filePath ?? "",
            history: allHistories ?? [],
            file: null,
            acceptedFormatsList: doc?.acceptedFormatsList,
            acceptedFormats: doc?.acceptedFormats,
            maxFileSizeKB: doc?.maxFileSizeKB,
          };
        }) ?? [];
    setDocuments(
      mergeDocumentRequirements(documentRequirements, uploadedDocuments),
    );

    // const approvalDocs = selectedRegistration.documents
    //   .filter((doc) => doc.moduleCode === "TO_REG_APPROVAL")
    //   .map((doc) => {
    //     const latestVersion = doc.versions?.[doc.versions.length - 1];
    //     const allHistories = doc.versions?.flatMap((version) => version.histories || []) || [];
    //     return {
    //       id: String(doc.documentId ?? ""),
    //       name: doc.documentName ?? "",
    //       file: null,
    //       isRequired: Boolean(doc.isMandatory),
    //       uploadedUrl: latestVersion?.filePath ?? "",
    //       versions: doc.versions,
    //       history: allHistories,
    //       acceptedFormatsList: doc?.acceptedFormatsList || [],  // ✅ FIX
    //     };
    //   });
    // setShowMisalHistory(approvalDocs)

    const mappedPartners: Partner[] = registration.partners.map(
      (p: Partner): Partner => ({
        id: p.partnerId,
        itsNumber: p.itsNumber,
        name: p.name,
        fullName: p.fullName ?? p.name,
        fatherName: p.fatherName ?? "",
        email: p.email,
        mobileNumber: p.mobile ?? "",
        dateOfBirth: p.dateOfBirth ?? "",
        address: p.address ?? "",
        role: p.role,
        isMainOperator: p.isMainOperator,
        tourOperatorId: p.tourOperatorId,
        approvedStatus: p.approvedStatus,

        isPartner: p.role?.toLowerCase() === "partner",
        isOfficeStaff: p.role?.toLowerCase() === "office_staff",
        loginRequired: Boolean(p.loginRequired),
        isAuthorizedGroupLeader: Boolean(p.isAuthorizedGroupLeader),

        permissionExpireDate: p?.permissionExpireDate,
        tourOperatorTypeId: p?.tourOperatorTypeId,
        isInclusive: p?.isInclusive,
        isPublic: p?.isPublic,
        permanentDiscount: p?.permanentDiscount,

        // Partner document appended
        documents:
          p.role?.toLowerCase() === "partner"
            ? mergeDocumentRequirements(
                documentRequirements,
                p.documents?.map((doc) => {
                  const latestVersion = doc.versions?.[0];
                  const allHistories =
                    doc.versions?.flatMap((version) =>
                      (version.histories || []).map((hist) => ({
                        ...hist,
                        filePath: version.filePath, // ✅ attach correct file
                      })),
                    ) || [];

                  return {
                    id: String(
                      doc.documentMasterId ?? doc.id ?? doc.documentId ?? "",
                    ),
                    documentId: String(doc.documentId ?? ""),
                    documentMasterId: String(doc?.documentMasterId ?? ""),
                    name: doc.documentName ?? doc.name ?? "",
                    status: doc.status ?? "",
                    isRequired: Boolean(doc.isMandatory),
                    uploadedUrl: latestVersion?.filePath ?? "",
                    history: allHistories ?? [],
                    file: null,
                    acceptedFormatsList: doc?.acceptedFormatsList,
                    acceptedFormats: doc?.acceptedFormats,
                    maxFileSizeKB: doc?.maxFileSizeKB,
                  };
                }) ?? [],
              )
            : [],

        addedAfterApproval: Boolean(p?.addedAfterApproval),
        partnerId: "",
        mobile: "",
        parentOperatorId: "",
        firstName: "",
        middleName: "",
        lastName: "",
        arabicName: "",
        gender: "Male",
        displayOnPublicPage: false,
        isActualPartner: false,
        hasLogin: false,
        isLocked: false,
        status: "pending",
        registeredDate: "",
      }),
    );
    setPartners(mappedPartners);
  }, [selectedRegistration, refetchApi, documentRequirements]);

  useEffect(() => {
    if (!selectedRegistration || !debouncedOfficeName) {
      setIsOfficeNameAvailable(null);
      return;
    }

    if (
      debouncedOfficeName.toLowerCase() ===
      selectedRegistration.officeName?.trim().toLowerCase()
    ) {
      setIsOfficeNameAvailable(true);
      setFormErrors((errors) => ({ ...errors, officeName: "" }));
      return;
    }

    let isCurrentRequest = true;
    const requestId = officeNameValidationRequestRef.current;

    const validateOfficeName = async () => {
      try {
        const isAvailable =
          await checkOfficeNameAvailability(debouncedOfficeName);
        if (
          !isCurrentRequest ||
          requestId !== officeNameValidationRequestRef.current
        ) {
          return;
        }

        setIsOfficeNameAvailable(isAvailable);
        setFormErrors((errors) => ({
          ...errors,
          officeName: isAvailable ? "" : "Office name already in use",
        }));
      } catch (error) {
        console.error("Failed to validate office name", error);
        if (isCurrentRequest) setIsOfficeNameAvailable(null);
      }
    };

    validateOfficeName();
    return () => {
      isCurrentRequest = false;
    };
  }, [debouncedOfficeName, selectedRegistration]);

  // const formatToInputDate = (dateString: string) => {
  //   if (!dateString) return '';
  //   const [datePart] = dateString.split(' ');
  //   const [month, day, year] = datePart.split('/');
  //   return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  // };

  // SET SAVE CONFIG FORM FEILDS
  // useEffect(() => {
  //   if (!selectedPartnerForConfig) return;

  //   setPermissionDate(
  //     selectedPartnerForConfig.permissionExpireDate
  //       ? formatToInputDate(selectedPartnerForConfig.permissionExpireDate)
  //       : ''
  //   );

  //   setToType(
  //     selectedPartnerForConfig.tourOperatorTypeId
  //       ? String(selectedPartnerForConfig.tourOperatorTypeId)
  //       : ''
  //   );

  //   setIsInclusive(Boolean(selectedPartnerForConfig.isInclusive));
  //   setIsRequiredForPublic(Boolean(selectedPartnerForConfig.isPublic));

  //   setPermanentDiscount(
  //     selectedPartnerForConfig.permanentDiscount !== null &&
  //       selectedPartnerForConfig.permanentDiscount !== undefined
  //       ? String(selectedPartnerForConfig.permanentDiscount)
  //       : ''
  //   );
  // }, [selectedPartnerForConfig]);

  // DELETE AREA OF OPERATION
  const handleRemoveArea = (area: AreaOfOperation) => {
    setAreaToDelete({
      areaId: String(area.areaId),
      tourOperatorId: String(area.tourOperatorId),
    });
    setIsAreaDeleteOpen(true);
  };

  const handleConfirmDeleteArea = async () => {
    if (!areaToDelete) return;
    try {
      setIsDeleting(true);
      const response = await deleteAreaOfOperation(
        areaToDelete.tourOperatorId,
        areaToDelete.areaId,
      );
      if (response?.deleted) {
        setAreasOfOperation((prev) =>
          prev.filter(
            (area) => Number(area.areaId) !== Number(areaToDelete.areaId),
          ),
        );
        toast.success("Area of operation deleted successfully");
      }
    } catch (error) {
      toast.error("Failed to delete area of operation");
    } finally {
      setIsAreaDeleteOpen(false);
      setAreaToDelete(null);
      setIsDeleting(false);
    }
  };

  //DELETE PARTNERS START
  const handleConfirmRemovePartner = async () => {
    if (!partnerToRemove) return;

    try {
      setIsDeleting(true);

      const response = await deletePartners(
        partnerToRemove.tourOperatorId,
        partnerToRemove.id,
      );

      if (response?.deleted) {
        //Remove from local partners list
        setPartners((prev) => prev.filter((p) => p.id !== partnerToRemove.id));
        //Remove partner configuration (if exists)
        // setPartnerConfigurations(prev =>
        //   prev.filter(c => c.partnerId !== partnerToRemove.id)
        // );
        toast.success("Member removed successfully");
      }
    } catch (error: unknown) {
      const errorMessage =
        error instanceof Error ? error.message : "Failed to remove member";

      toast.error(errorMessage);
    } finally {
      setIsPartnerRemoveDialogOpen(false);
      setPartnerToRemove(null);
      setIsDeleting(false);
    }
  };

  const handleAddArea = async () => {
    const nextErrors: Record<string, string> = {};
    const digits = currentArea.contactNumber.replace(/\D/g, "");

    if (!currentArea.countryId) {
      nextErrors["new-area-country"] = "Country is required";
    }
    if (currentArea.cityId === "" || currentArea.cityId === undefined) {
      nextErrors["new-area-city"] = "City is required";
    }
    if (String(currentArea.cityId) === "0" && !currentArea.otherCity.trim()) {
      nextErrors["new-area-city"] = "Other city name is required";
    }
    if (!currentArea.address.trim()) {
      nextErrors["new-area-address"] = "Address is required";
    }
    if (!currentArea.contactNumber.trim()) {
      nextErrors["new-area-contact"] = "Contact number is required";
    } else if (digits.length < 10 || digits.length > 15) {
      nextErrors["new-area-contact"] =
        "Contact number must be between 10 and 15 digits";
    }

    if (Object.keys(nextErrors).length > 0) {
      setFormErrors((errors) => ({ ...errors, ...nextErrors }));
      return;
    }

    if (!selectedRegistration?.tourOperatorId) {
      toast.error("Tour operator details are unavailable");
      return;
    }

    try {
      setIsAddingArea(true);
      const result = await AddAreaOfOpertaion({
        countryId: Number(currentArea.countryId),
        cityId: Number(currentArea.cityId),
        otherCity:
          String(currentArea.cityId) === "0"
            ? currentArea.otherCity.trim()
            : "",
        address: currentArea.address.trim(),
        contactNumber: currentArea.contactNumber.trim(),
        isAuthorizedGroupLeader: isAuthorizedGroupLead,
        tourOperatorId: Number(selectedRegistration.tourOperatorId),
      });

      if (!result.success) {
        toast.error(result.message || "Failed to add area of operation");
        return;
      }

      setCurrentArea({
        id: "",
        country: "",
        city: "",
        otherCity: "",
        address: "",
        contactNumber: "",
        countryId: "",
        cityId: "",
        tourOperatorId: "",
        areaId: 0,
      });
      setFormErrors((errors) => {
        const updated = { ...errors };
        delete updated["new-area-country"];
        delete updated["new-area-city"];
        delete updated["new-area-address"];
        delete updated["new-area-contact"];
        delete updated.areasOfOperation;
        return updated;
      });
      setRefetchApi((current) => !current);
      toast.success("Area of operation added successfully");
    } catch (error) {
      toast.error("Failed to add area of operation");
    } finally {
      setIsAddingArea(false);
    }
  };

  // const handleAddArea = async () => {
  //   const newErrors: AreaErrors = {};

  //   if (!currentArea.countryId) {
  //     newErrors.countryId = 'Please select a country for the area of operation';
  //   }

  //   if (!currentArea.cityId) {
  //     newErrors.cityId = 'Please select a city for the area of operation';
  //   }

  //   if (!currentArea.address.trim()) {
  //     newErrors.address = 'Please enter an address for the area of operation';
  //   }

  //   if (!currentArea.contactNumber.trim()) {
  //     newErrors.contactNumber = 'Please enter a contact number for the area of operation';
  //   } else {
  //     const digits = currentArea.contactNumber.replace(/\D/g, '');
  //     if (digits.length < 10 || digits.length > 15) {
  //       newErrors.contactNumber = 'Contact number must be between 10 and 15 digits';
  //     }
  //   }

  //   if (Object.keys(newErrors).length > 0) {
  //     setErrors(newErrors);
  //     return;
  //   }

  //   const payload = {
  //     countryId: Number(currentArea.countryId),
  //     cityId: currentArea.cityId === "not_listed" ? 0 : Number(currentArea.cityId),
  //     otherCity: currentArea.otherCity || '',
  //     address: currentArea.address.trim(),
  //     contactNumber: currentArea.contactNumber.replace(/\D/g, ''),
  //     isAuthorizedGroupLeader: Boolean(selectedRegistration?.isAuthorizedGroupLead),
  //     tourOperatorId: Number(selectedRegistration?.tourOperatorId),
  //   };

  //   setLoading(true)
  //   const result = await AddAreaOfOpertaion(payload);
  //   if (!result.success) {
  //     toast.error(result.message);
  //     setLoading(false)
  //     return;
  //   }

  //   // // ✅ API SUCCESS → update UI
  //   const newArea = {
  //     ...currentArea,
  //     id: Date.now().toString(),
  //     areaId: Number(result.data.areaId),
  //     tourOperatorId: Number(selectedRegistration?.tourOperatorId),
  //     cityId: currentArea.cityId === "not_listed" ? 0 : Number(currentArea.cityId),
  //   };

  //   setAreasOfOperation(prev => [...prev, newArea]);
  //   setCurrentArea({
  //     id: '',
  //     country: '',
  //     city: '',
  //     otherCity: '',
  //     address: '',
  //     contactNumber: '',
  //     countryId: '',
  //     cityId: '',
  //     tourOperatorId: '',
  //     areaId: ''
  //   });
  //   setLoading(false)
  //   setErrors({});
  //   toast.success('Area of operation added successfully');
  // };

  const handleApproved = async () => {
    if (!selectedRegistration) return;

    // const hasPartners = partners && partners.length > 0;
    // if (hasPartners) {
    //   const mainOperator = partners.find(p => p.isMainOperator === true);
    //   if (!mainOperator || !mainOperator.permissionExpireDate || !mainOperator.tourOperatorTypeId) {
    //     toast.error('Please configure the main operator before approval');
    //     return;
    //   }
    // } else {
    //   Original validation for non-partner TOs
    //   if (!permissionDate) {
    //     toast.error('Please set permission expiry date');
    //     return;
    //   }

    //   if (!toType) {
    //     toast.error('Please select tour operator type');
    //     return;
    //   }
    // }

    // const missingMisalRequiredDocs = misaldocuments.filter(
    //   (doc) => doc.isRequired && !doc.file
    // );

    // if (missingMisalRequiredDocs.length > 0) {
    //   toast.error("Please upload Misal Mubarak before approval");
    //   return false;
    // }

    try {
      setIsUploading(true);
      const formData = new FormData();
      formData.append(
        "TourOperatorId",
        String(selectedRegistration.tourOperatorId),
      );
      // formData.append("UserId", String(user?.id || ""));
      // formData.append("CreatedBy", String(user?.id || ""));
      // formData.append("Remarks", remarks || "");

      // ✅ Append documents
      // misaldocuments.forEach((doc, index) => {
      //   if (!doc.file) return; // ✅ guard
      //   formData.append(`Documents[${index}].documentMasterId`, String(doc.id));
      //   formData.append(`Documents[${index}].File`, doc.file);
      //   formData.append(`Documents[${index}].FileKey`, doc.file.name);
      // });

      const result = await ApprovedTourOperator(
        Number(selectedRegistration.tourOperatorId),
        formData,
        // Number(selectedRegistration.id)
      );
      toast.success(
        result?.response?.data ?? "Registration Approved successfully",
      );
      // navigate('/registration/list')
    } catch (error: unknown) {
      let errorMessage = "Failed to reject registration";
      if (axios.isAxiosError(error)) {
        if (typeof error.response?.data === "string") {
          errorMessage = error.response.data;
        } else {
          errorMessage = error.message;
        }
      } else if (error instanceof Error) {
        errorMessage = error.message;
      }
      toast.error(errorMessage);
    } finally {
      setIsUploading(false);
    }
  };

  const handleReject = async () => {
    if (!selectedRegistration) return;

    if (!rejectReason.trim()) {
      toast.error("Please provide a rejection reason");
      return;
    }

    try {
      setIsUploading(true);
      const result = await rejectTourOperator(
        Number(selectedRegistration.tourOperatorId),
        rejectReason,
        Number(selectedRegistration.id), // if available
      );

      const updatedRegistration: TORegistration = {
        ...selectedRegistration,
        status: "rejected",
        rejectedReason: rejectReason,
      };
      setSelectedRegistration(updatedRegistration);

      toast.success(
        result?.response?.data ?? "Registration rejected successfully",
      );
      navigate("/registration/list");
    } catch (error: unknown) {
      let errorMessage = "Failed to reject registration";
      if (axios.isAxiosError(error)) {
        // If API sends plain string
        if (typeof error.response?.data === "string") {
          errorMessage = error.response.data;
        } else {
          errorMessage = error.message;
        }
      } else if (error instanceof Error) {
        errorMessage = error.message;
      }
      toast.error(errorMessage);
    } finally {
      setIsUploading(false);
    }
  };

  // const handleDeleteDocument = (docId: string) => {
  //   setDocumentToDelete(docId);
  //   setIsDeleteDialogOpen(true);
  // };

  const toggleDocHistory = (docId: string) => {
    setExpandedDocHistory((prev) => ({
      ...prev,
      [docId]: !prev[docId],
    }));
  };

  const togglePartnerDocHistory = (key: string) => {
    setExpandedPartnerDocHistory((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const validateDocumentFile = (document: DocumentUpload, file: File) => {
    const allowedFormats = (
      document.acceptedFormatsList?.length
        ? document.acceptedFormatsList
        : (document.acceptedFormats?.split(",") ?? [])
    )
      .map((format) => format.trim().replace(/^\./, "").toLowerCase())
      .filter(Boolean);
    const extension = file.name.split(".").pop()?.toLowerCase();

    if (
      allowedFormats.length > 0 &&
      (!extension || !allowedFormats.includes(extension))
    ) {
      toast.error(
        `Accepted format: ${allowedFormats.join(", ").toUpperCase()} only`,
      );
      return false;
    }

    if (document.maxFileSizeKB) {
      const maxSizeBytes = Number(document.maxFileSizeKB) * 1024;
      const tolerance = 5 * 1024;
      if (file.size > maxSizeBytes + tolerance) {
        toast.error(
          `File size must be less than or equal to ${formatFileSizeFromKB(
            document.maxFileSizeKB,
          )}`,
        );
        return false;
      }
    }

    return true;
  };

  const selectMainDocumentFile = (documentId: string, file?: File) => {
    if (!file) return;
    const document = documents.find((item) => item.id === documentId);
    if (!document || !validateDocumentFile(document, file)) return;

    setDocuments((items) =>
      items.map((item) => (item.id === documentId ? { ...item, file } : item)),
    );
    setFormErrors((errors) => ({ ...errors, documents: "" }));
  };

  const selectPartnerDocumentFile = (
    partnerId: string,
    documentId: string,
    file?: File,
  ) => {
    if (!file) return;
    const partner = partners.find((item) => item.id === partnerId);
    const document = partner?.documents?.find((item) => item.id === documentId);
    if (!document || !validateDocumentFile(document, file)) return;

    setPartners((items) =>
      items.map((item) =>
        item.id === partnerId
          ? {
              ...item,
              documents: item.documents.map((partnerDocument) =>
                partnerDocument.id === documentId
                  ? { ...partnerDocument, file }
                  : partnerDocument,
              ),
            }
          : item,
      ),
    );
    setFormErrors((errors) => ({
      ...errors,
      [`partner-${partners.findIndex((item) => item.id === partnerId)}-documents`]:
        "",
    }));
  };

  // const confirmDeleteDocument = async () => {
  //   if (!deleteRemark.trim()) {
  //     toast.error("Please provide a reason for document deletion");
  //     return;
  //   }
  //   if (!documentToDelete) return;
  //   try {
  //     setIsUploading(true)
  //     const result = await rejectTourOperatorDocument(
  //       Number(documentToDelete),
  //       deleteRemark,
  //     );
  //     // update UI after success
  //     setDocuments(prev =>
  //       prev.map(doc =>
  //         doc.id === documentToDelete
  //           ? { ...doc, uploadedUrl: undefined, file: null }
  //           : doc
  //       )
  //     );
  //     toast.success(result?.response?.data ?? "Document rejected successfully");
  //     setRefetchApi(!refetchApi)
  //     setIsDeleteDialogOpen(false);
  //     setDocumentToDelete(null);
  //     setDeleteRemark("");
  //   } catch (error: unknown) {
  //     let errorMessage = "Failed to reject document";
  //     if (axios.isAxiosError(error)) {
  //       if (typeof error.response?.data === "string") {
  //         errorMessage = error.response.data;
  //       } else {
  //         errorMessage = error.message;
  //       }
  //     } else if (error instanceof Error) {
  //       errorMessage = error.message;
  //     }
  //     toast.error(errorMessage);
  //   } finally {
  //     setIsUploading(false)
  //   }
  // };

  const handleNewConfirmUpload = async () => {
    if (!rejectedDoc || reUploadFiles.length === 0) {
      toast.error("Please select a file");
      return;
    }

    const file = reUploadFiles[0];
    /* ------------------ File Size Validation ------------------ */
    const maxSizeMB = Number(rejectedDoc?.maxFileSizeKB || 0) / 1024;
    const fileSizeMB = file.size / (1024 * 1024);

    if (fileSizeMB > maxSizeMB + 0.01) {
      toast.error(`File size must be less than or equal to ${maxSizeMB} MB`);
      return;
    }

    /* ------------------ Accepted Format Validation ------------------ */
    if (rejectedDoc?.acceptedFormats?.trim()) {
      const fileExtension = file.name.split(".").pop()?.toLowerCase();

      const allowedFormats = rejectedDoc.acceptedFormats
        .split(",")
        .map((f) => f.trim().toLowerCase())
        .filter(Boolean);

      if (!fileExtension || !allowedFormats.includes(fileExtension)) {
        toast.error(
          `Accepted format: ${allowedFormats.join(", ")} Only (Max ${formatFileSizeFromKB(
            rejectedDoc.maxFileSizeKB,
          )})`,
        );
        return;
      }
    }

    try {
      setIsUploading(true); // ✅ start loading
      const formData = new FormData();
      formData.append("File", file);
      formData.append(
        "TourOperatorId",
        String(selectedRegistration?.tourOperatorId),
      );
      formData.append("DocumentMasterId", String(rejectedDoc.documentMasterId));

      if (rejectedDoc.isPartner && rejectedDoc.partnerid) {
        formData.append("PartnerId", String(rejectedDoc.partnerid));
      }

      let response;

      if (rejectedDoc.isPartner) {
        response = await reUploadPartnersDocuments(formData);
      } else {
        response = await reUploadTourDocuments(formData);
      }

      toast.success(response || "Document re-uploaded successfully.");

      setRefetchApi(!refetchApi);
      setShowUploadDialog(false);
      setRejectedDoc(null);
      setReuploadFiles([]);
    } catch (error) {
      let errorMessage = "Failed to re-upload document";
      if (axios.isAxiosError(error)) {
        errorMessage =
          typeof error.response?.data === "string"
            ? error.response.data
            : error.message;
      } else if (error instanceof Error) {
        errorMessage = error.message;
      }
      toast.error(errorMessage);
    } finally {
      setIsUploading(false); // ✅ stop loading (very important)
    }
  };

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case "approved":
        return "bg-green-100 text-green-700 border-green-300";
      case "pending":
        return "bg-amber-100 text-amber-700 border-amber-300";
      case "rejected":
        return "bg-red-100 text-red-700 border-red-300";
      default:
        return "bg-gray-100 text-gray-700 border-gray-300";
    }
  };

  // Add More Partner on review Management Functions
  const handleOpenPartnerDialog = async () => {
    setIsPartnerDialogOpen(true);
    setAddPartnerErrors({});
    setPartnerFormData({
      id: "",
      isNonItsPartner: false,
      itsNumber: "",
      name: "",
      fullName: "",
      fatherName: "",
      email: "",
      mobileNumber: "",
      dateOfBirth: "",
      address: "",
      role: "",
      isPartner: false,
      isOfficeStaff: businessType === "sole_proprietor",
      loginRequired: false,
      isAuthorizedGroupLeader: false,
      documents: documents.map((doc) => ({
        id: doc.id,
        documentMasterId: doc.documentMasterId,
        name: doc.name,
        status: doc.status,
        file: null,
        isRequired: doc.isRequired,
        acceptedFormats: doc?.acceptedFormats,
        maxFileSizeKB: doc?.maxFileSizeKB,
      })),
      addedAfterApproval: false,
    });
  };

  const handlePartnerFileUpload = useCallback(
    (docId: string, file: File | null) => {
      setPartnerFormData({
        ...partnerFormData,
        documents: partnerFormData.documents.map((doc) =>
          doc.id === docId ? { ...doc, file } : doc,
        ),
      });
    },
    [partnerFormData],
  );

  const validatePartnerDocuments = useCallback(() => {
    if (!partnerFormData.isPartner) {
      return true;
    }

    const missingRequiredDocs = partnerFormData.documents.filter(
      (doc) => doc.isRequired && !doc.file,
    );

    if (missingRequiredDocs.length > 0) {
      return false;
    }

    return true;
  }, [partnerFormData.documents, partnerFormData.isPartner]);

  const handleSavePartner = useCallback(async () => {
    if (!selectedRegistration) {
      throw new Error("Selected registration is missing");
    }

    const errors: PartnerFormErrors = {};

    if (!partnerFormData.isNonItsPartner && !partnerFormData.itsNumber) {
      errors.itsNumber = "ITS number is required";
    }

    if (!partnerFormData.name) {
      errors.name = "Name is required";
    }

    if (!partnerFormData.email.trim()) {
      errors.email = "Email is required";
    } else if (!EMAIL_PATTERN.test(partnerFormData.email.trim())) {
      errors.email = "Please enter a valid email address";
    }

    if (!partnerFormData.mobileNumber) {
      errors.mobileNumber = "Mobile number is required";
    }

    if (!partnerFormData.isPartner && !partnerFormData.isOfficeStaff) {
      errors.memberType = "Please select Partner or Office Staff";
    }

    if (!validatePartnerDocuments()) {
      errors.documents = "Please upload all required documents";
    }

    // Stop submit if errors exist
    if (Object.keys(errors).length > 0) {
      setAddPartnerErrors(errors);
      return;
    }

    // DUPLICATE EMAIL CHECK FROM EXISTING PARTNERS
    const normalizedEmail = partnerFormData.email.trim().toLowerCase();
    const isEmailExists = partners.some(
      (p) => p.email.toLowerCase() === normalizedEmail,
    );
    if (isEmailExists) {
      setAddPartnerErrors((prev) => ({
        ...prev,
        email: "This email already exists",
      }));
      return;
    }

    // Clear errors on success
    setAddPartnerErrors({});
    try {
      const formData = new FormData();
      formData.append("itsNumber", partnerFormData.itsNumber);
      formData.append(
        "IsNonIts",
        partnerFormData.isNonItsPartner ? "true" : "false",
      );
      formData.append("name", partnerFormData.name);
      formData.append("email", partnerFormData.email);
      formData.append("mobile", partnerFormData.mobileNumber);
      formData.append(
        "role",
        partnerFormData.isPartner ? "PARTNER" : "OFFICE_STAFF",
      );
      formData.append("loginRequired", String(partnerFormData.loginRequired));
      formData.append(
        "isAuthorizedGroupLeader",
        String(partnerFormData.isAuthorizedGroupLeader),
      );
      formData.append("isMainOperator", "false");
      formData.append(
        "tourOperatorId",
        String(selectedRegistration?.tourOperatorId),
      );

      if (partnerFormData.isPartner) {
        partnerFormData.documents?.forEach((doc, dIndex) => {
          if (doc.file) {
            formData.append(
              `Documents[${dIndex}].documentMasterId`,
              String(doc.documentMasterId),
            );
            formData.append(`Documents[${dIndex}].file`, doc.file);
            formData.append(`Documents[${dIndex}].FileKey`, doc.file.name);
          }
        });
      }

      const result = await AddNewPartners(formData);
      if (!result?.success) {
        toast.error(result?.message || "Failed to add partner");
        return;
      }
      // ✅ manually add partner to UI state
      // const newPartner = createLocalPartnerFromPayload(payload);
      // setPartners(prev => [...prev, newPartner]);
      toast.success("Member added successfully");
      setRefetchApi(!refetchApi);
    } catch (error: unknown) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "Something went wrong. Please try again.";
      toast.error(errorMessage);
    } finally {
      setIsPartnerDialogOpen(false);
    }
  }, [
    partnerFormData,
    selectedRegistration,
    validatePartnerDocuments,
    refetchApi,
    partners,
  ]);

  const handleUpdateRegistration = async () => {
    if (!selectedRegistration) return;

    const nextErrors: Record<string, string> = {};
    const phonePattern = /^[\d\s\-+()]+$/;

    if (!mobileNumber.trim()) {
      nextErrors.mobileNumber = "Mobile number is required";
    } else if (!phonePattern.test(mobileNumber)) {
      nextErrors.mobileNumber = "Please enter a valid mobile number";
    }
    if (alternateMobile && !phonePattern.test(alternateMobile)) {
      nextErrors.alternateMobile = "Please enter a valid alternate number";
    }
    if (!officeNumber.trim()) {
      nextErrors.officeNumber = "Office contact number is required";
    } else if (!phonePattern.test(officeNumber)) {
      nextErrors.officeNumber = "Please enter a valid office contact number";
    }
    if (!officeName.trim()) nextErrors.officeName = "Office name is required";
    else if (isOfficeNameAvailable === false) {
      nextErrors.officeName = "Office name already in use";
    }
    if (!businessType) nextErrors.businessType = "Business type is required";
    if (!country) nextErrors.country = "Country is required";
    if (!city) nextErrors.city = "City is required";
    if (!permanentAddress.trim()) {
      nextErrors.permanentAddress = "Permanent address is required";
    }
    if (areasOfOperation.length === 0) {
      nextErrors.areasOfOperation =
        "At least one area of operation is required";
    }
    if (
      documents.some(
        (document) =>
          document.isRequired && !document.file && !document.uploadedUrl,
      )
    ) {
      nextErrors.documents =
        "Please provide all required registration documents";
    }
    areasOfOperation.forEach((area, index) => {
      if (!area.countryId)
        nextErrors[`area-${index}-country`] = "Country is required";
      if (
        area.cityId === "" ||
        area.cityId === null ||
        area.cityId === undefined
      ) {
        nextErrors[`area-${index}-city`] = "City is required";
      }
      if (String(area.cityId) === "0" && !area.otherCity?.trim()) {
        nextErrors[`area-${index}-city`] = "Other city name is required";
      }
      if (!area.address.trim())
        nextErrors[`area-${index}-address`] = "Address is required";
      if (!area.contactNumber.trim()) {
        nextErrors[`area-${index}-contact`] = "Contact number is required";
      } else if (!phonePattern.test(area.contactNumber)) {
        nextErrors[`area-${index}-contact`] = "Enter a valid contact number";
      }
    });

    partners
      .filter((partner) => !partner.isMainOperator)
      .forEach((partner, index) => {
        if (!partner.fullName.trim()) {
          nextErrors[`partner-${index}-name`] = "Member name is required";
        }
        if (!partner.email.trim()) {
          nextErrors[`partner-${index}-email`] = "Member email is required";
        } else if (!EMAIL_PATTERN.test(partner.email.trim())) {
          nextErrors[`partner-${index}-email`] = "Enter a valid member email";
        }
        if (!partner.mobileNumber.trim()) {
          nextErrors[`partner-${index}-mobile`] = "Member mobile is required";
        }
        if (!partner.isPartner && !partner.isOfficeStaff) {
          nextErrors[`partner-${index}-role`] =
            "Select Partner or Office Staff";
        }
        if (
          partner.isPartner &&
          partner.documents?.some(
            (document) =>
              document.isRequired && !document.file && !document.uploadedUrl,
          )
        ) {
          nextErrors[`partner-${index}-documents`] =
            "Please provide all required member documents";
        }
      });

    setFormErrors(nextErrors);
    if (Object.keys(nextErrors).length > 0) {
      toast.error("Please correct the highlighted fields");
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const hasOfficeNameChanged =
      officeName.trim().toLowerCase() !==
      selectedRegistration.officeName?.trim().toLowerCase();
    if (hasOfficeNameChanged) {
      try {
        const isAvailable = await checkOfficeNameAvailability(officeName);
        setIsOfficeNameAvailable(isAvailable);
        if (!isAvailable) {
          setFormErrors((errors) => ({
            ...errors,
            officeName: "Office name already in use",
          }));
          toast.error("Office name already in use");
          return;
        }
      } catch (error) {
        console.error("Failed to validate office name", error);
        toast.error("Unable to validate office name. Please try again.");
        return;
      }
    }

    try {
      setIsUpdating(true);
      const payload = new FormData();
      payload.append(
        "TourOperatorId",
        String(selectedRegistration.tourOperatorId),
      );
      payload.append("ITSNumber", selectedRegistration.itsNumber || "");
      payload.append("FirstName", firstName);
      payload.append("MiddleName", middleName);
      payload.append("LastName", lastName);
      payload.append("ArabicName", arabicName);
      payload.append("Gender", gender.toLowerCase());
      payload.append("DateOfBirth", dateOfBirth);
      payload.append("Email", selectedRegistration.email || "");
      payload.append("MobileNumber", mobileNumber.trim());
      payload.append("AlternateMobile", alternateMobile.trim());
      payload.append("WhatsAppUsername", whatsappUsername.trim());
      payload.append("OfficeName", officeName.trim());
      payload.append("OfficeNumber", officeNumber.trim());
      payload.append("BusinessType", businessType);
      payload.append(
        "LoginRequired",
        String(selectedRegistration.loginRequired),
      );
      payload.append("CountryId", country);
      payload.append("CityId", "0");
      payload.append("OtherCity", city.trim());
      payload.append("PermanentAddress", permanentAddress.trim());
      payload.append("IsAuthorizedGroupLead", String(isAuthorizedGroupLead));
      payload.append("CreatedBy", String(Number(user?.id) || 0));

      areasOfOperation.forEach((area, index) => {
        payload.append(
          `AreasOfOperation[${index}].TourOperatorId`,
          String(selectedRegistration.tourOperatorId),
        );
        payload.append(
          `AreasOfOperation[${index}].AreaId`,
          String(area.areaId || 0),
        );
        payload.append(
          `AreasOfOperation[${index}].CountryId`,
          String(area.countryId || area.country),
        );
        payload.append(
          `AreasOfOperation[${index}].CityId`,
          String(area.cityId ?? area.city ?? ""),
        );
        payload.append(
          `AreasOfOperation[${index}].OtherCity`,
          String(area.cityId ?? area.city) === "0" ? area.otherCity || "" : "",
        );
        payload.append(
          `AreasOfOperation[${index}].Address`,
          area.address.trim(),
        );
        payload.append(
          `AreasOfOperation[${index}].ContactNumber`,
          area.contactNumber.trim(),
        );
        payload.append(
          `AreasOfOperation[${index}].IsAuthorizedGroupLeader`,
          String(isAuthorizedGroupLead),
        );
      });

      partners.forEach((partner, index) => {
        payload.append(
          `Partners[${index}].PartnerId`,
          String(Number(partner.id) || 0),
        );
        payload.append(`Partners[${index}].ITSNumber`, partner.itsNumber);
        payload.append(
          `Partners[${index}].Name`,
          partner.fullName || partner.name,
        );
        payload.append(`Partners[${index}].Email`, partner.email);
        payload.append(
          `Partners[${index}].Mobile`,
          partner.mobileNumber || partner.mobile,
        );
        payload.append(
          `Partners[${index}].Role`,
          partner.isPartner
            ? "PARTNER"
            : partner.isOfficeStaff
              ? "OFFICE_STAFF"
              : partner.role.toUpperCase(),
        );
        payload.append(
          `Partners[${index}].LoginRequired`,
          String(partner.loginRequired),
        );
        payload.append(
          `Partners[${index}].IsAuthorizedGroupLeader`,
          String(partner.isAuthorizedGroupLeader),
        );
        payload.append(
          `Partners[${index}].IsMainOperator`,
          String(partner.isMainOperator),
        );
        payload.append(
          `Partners[${index}].AddedAfterApproval`,
          String(Boolean(partner.addedAfterApproval)),
        );

        if (!partner.isPartner) return;
        partner.documents?.forEach((document, documentIndex) => {
          if (!document.file) return;
          payload.append(
            `Partners[${index}].Documents[${documentIndex}].documentMasterId`,
            String(document.id),
          );
          payload.append(
            `Partners[${index}].Documents[${documentIndex}].file`,
            document.file,
          );
          payload.append(
            `Partners[${index}].Documents[${documentIndex}].FileKey`,
            document.file.name,
          );
        });
      });

      documents.forEach((document, index) => {
        if (!document.file) return;
        payload.append(
          `Documents[${index}].documentMasterId`,
          String(document.id),
        );
        payload.append(`Documents[${index}].File`, document.file);
        payload.append(`Documents[${index}].FileKey`, document.file.name);
      });

      // console.table(
      //   Array.from(payload.entries()).map(([field, value]) => ({
      //     field,
      //     value: value instanceof File ? `File: ${value.name}` : value,
      //   })),
      // );

      const response = await updateTourOperatorRegistration(
        Number(selectedRegistration.tourOperatorId),
        payload,
      );
      toast.success(response?.message || "Registration updated successfully");
      await fetchRegistrationDetails();
    } catch (error: unknown) {
      const message = axios.isAxiosError(error)
        ? error.response?.data?.message || error.response?.data || error.message
        : error instanceof Error
          ? error.message
          : "Failed to update registration";
      toast.error(
        typeof message === "string" ? message : "Failed to update registration",
      );
    } finally {
      setIsUpdating(false);
    }
  };

  // const hasRejectedDocuments = selectedRegistration?.documents?.some(d => d?.isRejected) || selectedRegistration?.partners?.some(p =>
  //   p?.documents?.some(d => d?.isRejected)
  // ) || false;

  const hasRejectedDocuments =
    selectedRegistration?.documents?.some(
      (doc) =>
        doc?.status === "REJECTED" ||
        doc?.versions?.some((v) => v?.documentVersionStatus === "REJECTED"),
    ) ||
    selectedRegistration?.partners?.some((partner) =>
      partner?.documents?.some(
        (doc) =>
          doc?.status === "REJECTED" ||
          doc?.versions?.some((v) => v?.documentVersionStatus === "REJECTED"),
      ),
    ) ||
    false;

  const isApproved = selectedRegistration?.status?.toLowerCase() === "approved";
  const isPending = selectedRegistration?.status?.toLowerCase() === "pending";
  const isRejected = selectedRegistration?.status?.toLowerCase() === "rejected";

  // Form View
  return (
    <>
      {loading && <FullScreenLoading />}
      <div className="space-y-6">
        {/* FIRST CARD  */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 bg-white p-4 rounded-lg border border-gray-200">
          <div className="flex items-center gap-3">
            <Badge
              variant="outline"
              className={`${getStatusColor(selectedRegistration?.status || "pending")} text-[10px] px-1.5 py-0.5`}
            >
              {selectedRegistration?.status}
            </Badge>
            {isRejected &&
              (selectedRegistration?.rejectReason ||
                selectedRegistration?.rejectedReason) && (
                <p className="text-sm text-red-600">
                  {selectedRegistration.rejectReason ||
                    selectedRegistration.rejectedReason}
                </p>
              )}
          </div>
          <div className="flex items-center gap-2">
            <p className="text-sm text-gray-600">ITS Number:</p>
            <p className="font-mono text-gray-900 font-semibold">
              {selectedRegistration?.itsNumber}
            </p>
          </div>
        </div>

        {/* SECOND CARD */}
        {hasRejectedDocuments && isPending && (
          <Alert className="border-red-500 bg-red-50">
            <AlertCircle className="w-4 h-4 text-red-600" />
            <AlertDescription className="text-red-800">
              <strong>Action Required:</strong> Some documents have been
              rejected by the admin. Please review the rejection reasons below
              and re-upload the correct documents. You cannot submit for
              approval until all issues are resolved.
            </AlertDescription>
          </Alert>
        )}

        {isApproved && (
          <Alert className="border-green-500 bg-green-50">
            <CheckCircle2 className="w-4 h-4 text-green-600" />
            <AlertDescription className="text-green-800">
              <strong>Registration Approved:</strong> Your tour operator
              registration has been approved by the admin. All information is
              now locked and cannot be modified.
            </AlertDescription>
          </Alert>
        )}

        {isPending && !hasRejectedDocuments && (
          <Alert className="border-[#5B9BD5]/20 bg-[#5B9BD5]/5">
            <AlertCircle className="w-4 h-4" style={{ color: "#5B9BD5" }} />
            <AlertDescription style={{ color: "#5B9BD5" }}>
              <strong>Under Review:</strong> Your registration is being reviewed
              by the admin. You can update your registration information, add
              members, or re-upload rejected documents.
            </AlertDescription>
          </Alert>
        )}

        {/* FORM SECTION START */}
        {/* ITS Verified Information - All Editable Except ITS Number */}
        <Card className="border-[#5B9BD5]/30 bg-white shadow-lg">
          <CardHeader>
            <div className="flex items-center justify-between">
              <div>
                <div className="flex items-center gap-2">
                  <ShieldCheck
                    className="w-5 h-5"
                    style={{ color: "#5B9BD5" }}
                  />
                  <CardTitle className="text-gray-900">
                    Verified Personal Information (ITS Data)
                  </CardTitle>
                </div>
                <p className="text-sm text-gray-600 mt-1">
                  Information verified from ITS system (read-only - cannot be
                  modified)
                </p>
              </div>
              <Badge
                variant="outline"
                className="bg-green-50 text-green-700 border-green-200"
              >
                <ShieldCheck className="w-3 h-3 mr-1" />
                Verified
              </Badge>
            </div>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="space-y-2">
                <InputFieldset
                  label="ITS Number"
                  id="itsNumber"
                  value={selectedRegistration?.itsNumber || "N/A"}
                  readOnly
                  disabled
                  tabIndex={-1}
                  className="!bg-gray-100 cursor-not-allowed font-mono tracking-wider [&_legend]:!bg-gray-100"
                />
              </div>

              <div className="space-y-2">
                <InputFieldset
                  label="First Name"
                  id="firstName"
                  readOnly={true}
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  placeholder="Enter first name"
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                  disabled={activeTab !== "pending"}
                />
              </div>

              <div className="space-y-2">
                <InputFieldset
                  label="Middle Name"
                  id="middleName"
                  readOnly={true}
                  value={middleName}
                  onChange={(e) => setMiddleName(e.target.value)}
                  placeholder="Enter middle name"
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                  disabled={activeTab !== "pending"}
                />
              </div>

              <div className="space-y-2">
                <InputFieldset
                  label="Last Name"
                  id="lastName"
                  readOnly={true}
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  placeholder="Enter last name"
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                  disabled={activeTab !== "pending"}
                />
              </div>

              <div className="space-y-2 lg:col-span-2">
                <InputFieldset
                  label="Arabic Name"
                  id="arabicName"
                  readOnly
                  value={arabicName}
                  onChange={(e) => setArabicName(e.target.value)}
                  placeholder="Enter Arabic name"
                  dir="rtl"
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                  disabled={activeTab !== "pending"}
                />
              </div>

              <div className="space-y-2">
                <InputFieldset
                  label="Gender"
                  id="gender"
                  value={gender || "N/A"}
                  readOnly
                  disabled
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                />
              </div>

              <div className="space-y-2">
                <InputFieldset
                  label="Date of Birth"
                  id="dateOfBirth"
                  value={dateOfBirth || "N/A"}
                  readOnly
                  disabled
                  className="!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100"
                />
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Editable Additional Information */}
        <Card className="border-[#5B9BD5]/20 bg-white shadow-lg">
          <CardHeader>
            <div className="flex items-center justify-between">
              <div>
                <div className="flex items-center gap-2">
                  <User className="w-5 h-5" style={{ color: "#5B9BD5" }} />
                  <CardTitle className="text-gray-900">
                    Additional Information
                  </CardTitle>
                </div>
                <p className="text-sm text-gray-600 mt-1">
                  Update your contact, business, and location details
                </p>
              </div>
              {isApproved ? (
                <Badge
                  variant="outline"
                  className="bg-gray-50 text-gray-700 border-gray-300"
                >
                  Read-Only
                </Badge>
              ) : (
                <Badge
                  variant="outline"
                  className="bg-sky-50 text-sky-700 border-sky-200"
                >
                  Editable
                </Badge>
              )}
            </div>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="space-y-2">
                <InputFieldset
                  label="Whatsapp Username"
                  id="whatsappUsername"
                  value={whatsappUsername}
                  onChange={(e) => {
                    setWhatsappUsername(e.target.value);
                    setFormErrors((errors) => ({
                      ...errors,
                      whatsappUsername: "",
                    }));
                  }}
                  placeholder="e.g., JohnDoe"
                  className={cn(
                    formErrors.whatsappUsername && "border-red-500",
                    isApproved &&
                      "!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100",
                  )}
                  disabled={isApproved}
                />
                {formErrors.whatsappUsername && (
                  <p className="text-xs text-red-600">
                    {formErrors.whatsappUsername}
                  </p>
                )}
              </div>

              <div className="space-y-2">
                <InputFieldset
                  label="Mobile Number"
                  required
                  id="mobileNumber"
                  value={mobileNumber}
                  onChange={(e) => {
                    setMobileNumber(validatePhoneNumberInput(e.target.value));
                    setFormErrors((errors) => ({
                      ...errors,
                      mobileNumber: "",
                    }));
                  }}
                  placeholder="+964-XXX-XXXXXXX"
                  className={cn(
                    formErrors.mobileNumber && "border-red-500",
                    isApproved &&
                      "!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100",
                  )}
                  disabled={isApproved}
                />
                {formErrors.mobileNumber && (
                  <p className="text-xs text-red-600">
                    {formErrors.mobileNumber}
                  </p>
                )}
              </div>

              <div className="space-y-2">
                <InputFieldset
                  label="Alternate Mobile Number"
                  id="alternateMobile"
                  value={alternateMobile}
                  onChange={(e) => {
                    setAlternateMobile(
                      validatePhoneNumberInput(e.target.value),
                    );
                    setFormErrors((errors) => ({
                      ...errors,
                      alternateMobile: "",
                    }));
                  }}
                  placeholder="+964-XXX-XXXXXXX"
                  className={cn(
                    formErrors.alternateMobile && "border-red-500",
                    isApproved &&
                      "!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100",
                  )}
                  disabled={isApproved}
                />
                {formErrors.alternateMobile && (
                  <p className="text-xs text-red-600">
                    {formErrors.alternateMobile}
                  </p>
                )}
              </div>

              <div className="space-y-2">
                <InputFieldset
                  label="Office Contact Number"
                  required
                  id="officeNumber"
                  value={officeNumber}
                  onChange={(e) => {
                    setOfficeNumber(validatePhoneNumberInput(e.target.value));
                    setFormErrors((errors) => ({
                      ...errors,
                      officeNumber: "",
                    }));
                  }}
                  placeholder="+964-XXX-XXXXXXX"
                  className={cn(
                    formErrors.officeNumber && "border-red-500",
                    isApproved &&
                      "!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100",
                  )}
                  disabled={isApproved}
                />
                {formErrors.officeNumber && (
                  <p className="text-xs text-red-600">
                    {formErrors.officeNumber}
                  </p>
                )}
              </div>

              <div className="space-y-2 lg:col-span-2">
                <InputFieldset
                  label="Office Name"
                  required
                  id="officeName"
                  value={officeName}
                  onChange={(e) => {
                    officeNameValidationRequestRef.current += 1;
                    setOfficeName(e.target.value);
                    setIsOfficeNameAvailable(null);
                    setFormErrors((errors) => ({ ...errors, officeName: "" }));
                  }}
                  className={cn(
                    formErrors.officeName && "border-red-500",
                    isApproved &&
                      "!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100",
                  )}
                  disabled={isApproved}
                />
                {formErrors.officeName && (
                  <p className="text-xs text-red-600">
                    {formErrors.officeName}
                  </p>
                )}
              </div>

              <div className="space-y-2 lg:col-span-2">
                <SearchableSelectFieldset
                  label="Business Type"
                  value={businessType}
                  options={[
                    { value: "sole_proprietor", label: "Sole Proprietor" },
                    { value: "partnership", label: "Partnership" },
                    { value: "llp", label: "LLP" },
                    { value: "company", label: "Company" },
                  ]}
                  placeholder="Select business type..."
                  searchPlaceholder="Search business type..."
                  error={formErrors.businessType}
                  disabled={isApproved}
                  onChange={(value) => {
                    setBusinessType(value);
                    setFormErrors((errors) => ({
                      ...errors,
                      businessType: "",
                    }));
                  }}
                />
              </div>

              <div className="space-y-2 lg:col-span-2">
                <SearchableSelectFieldset
                  label="Country"
                  value={country}
                  options={countriesList.map((item) => ({
                    value: String(item.countryId),
                    label: item.countryName,
                  }))}
                  placeholder="Select country..."
                  searchPlaceholder="Search country..."
                  error={formErrors.country}
                  disabled={isApproved}
                  onChange={(value) => {
                    setCountry(value);
                    setFormErrors((errors) => ({
                      ...errors,
                      country: "",
                    }));
                  }}
                />
              </div>

              <div className="space-y-2 lg:col-span-2">
                <InputFieldset
                  label="City"
                  required
                  value={city}
                  placeholder="Enter city name"
                  disabled={isApproved}
                  onChange={(event) => {
                    setCity(event.target.value);
                    setFormErrors((errors) => ({ ...errors, city: "" }));
                  }}
                  className={cn(
                    formErrors.city && "border-red-500",
                    isApproved &&
                      "!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100",
                  )}
                />
                {formErrors.city && (
                  <p className="text-xs text-red-600">{formErrors.city}</p>
                )}
              </div>

              <div className="space-y-2 lg:col-span-4">
                <SelectFieldset
                  label="Permanent Address"
                  className={cn(
                    isApproved &&
                      "!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100",
                  )}
                >
                  <TextareaUI
                    id="permanentAddress"
                    value={permanentAddress}
                    onChange={(e) => {
                      setPermanentAddress(e.target.value);
                      setFormErrors((errors) => ({
                        ...errors,
                        permanentAddress: "",
                      }));
                    }}
                    placeholder="Enter your complete permanent address"
                    className={cn(
                      "min-h-[60px]",
                      isApproved && "cursor-not-allowed !bg-gray-100",
                    )}
                    disabled={isApproved}
                  />
                </SelectFieldset>
                {formErrors.permanentAddress && (
                  <p className="text-xs text-red-600">
                    {formErrors.permanentAddress}
                  </p>
                )}
              </div>

              {/* Authorized Group Leader - Only show if business type is Sole Proprietorship */}
              {businessType === "sole_proprietor" && (
                <div className="space-y-2 lg:col-span-4">
                  <CheckboxFieldset
                    label="Authorized Group Leader"
                    className="bg-white border-gray-300 rounded-lg"
                  >
                    <Checkbox
                      id="isAuthorizedGroupLeader"
                      checked={isAuthorizedGroupLead}
                      onCheckedChange={(checked) =>
                        setIsAuthorizedGroupLead(!!checked)
                      }
                      disabled={isApproved}
                    />
                  </CheckboxFieldset>
                </div>
              )}
            </div>
          </CardContent>
        </Card>

        {/* UPLOAD DOCUMENTS */}
        <Card className="border-[#5B9BD5]/20 bg-white shadow-lg">
          <CardHeader>
            <div className="flex items-center gap-2">
              <FileText className="w-5 h-5" style={{ color: "#5B9BD5" }} />
              <CardTitle className="text-gray-900">
                Uploaded Documents <span className="text-red-500">*</span>
              </CardTitle>
            </div>
            <p className="text-sm text-gray-600 mt-1">
              {hasRejectedDocuments
                ? "Review rejected documents and re-upload corrected versions"
                : "Required documents for registration"}
            </p>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {formErrors.documents && (
                <Alert
                  variant="destructive"
                  className="!border-red-500 !bg-red-50"
                >
                  <AlertCircle className="h-4 w-4 !text-red-500" />
                  <AlertDescription className="!text-red-600">
                    {formErrors.documents}
                  </AlertDescription>
                </Alert>
              )}
              {documents.map((doc, index) => (
                <div
                  key={doc.id}
                  className="border border-gray-200 rounded-lg overflow-hidden"
                >
                  {/* Document Row */}
                  <div className="bg-white hover:bg-gray-50 transition-colors p-4">
                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
                      <span className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-100 text-gray-900 flex-shrink-0">
                        {index + 1}
                      </span>
                      <div className="flex-1 min-w-0">
                        <p className="text-gray-900">
                          {doc.name || doc.documentName}
                          {doc.isRequired ||
                            (doc?.isMandatory && (
                              <span className="text-red-500 ml-1">*</span>
                            ))}
                        </p>
                        <p className="text-xs text-red-400">
                          {`Accepted format: ${doc.acceptedFormatsList?.join(", ") || doc.acceptedFormats || "Any"} (Max ${formatFileSizeFromKB(
                            doc.maxFileSizeKB,
                          )})`}
                        </p>
                      </div>
                      <div className="flex flex-wrap items-center gap-2 sm:gap-3 w-full sm:w-auto">
                        {doc.status === "REJECTED" ? (
                          <Badge className="bg-red-100 text-red-700 border-0 text-[10px] px-1.5 py-0.5">
                            Rejected
                          </Badge>
                        ) : doc.uploadedUrl ? (
                          <>
                            <CheckCircle2 className="w-5 h-5 text-green-600" />
                            <span className="text-sm text-green-700">
                              uploaded
                            </span>
                            <button
                              className="hover:bg-gray-100 rounded-lg p-1.5 transition-colors"
                              style={{ color: "#5B9BD5" }}
                            >
                              <Eye
                                className="w-4 h-4 cursor-pointer"
                                onClick={() => {
                                  const fullUrl = getFileViewUrl(
                                    doc.uploadedUrl,
                                  );
                                  window.open(fullUrl, "_blank");
                                }}
                              />
                            </button>
                          </>
                        ) : (
                          <Badge className="bg-gray-200 text-gray-700 border-0 text-[10px] px-1.5 py-0.5">
                            Not Uploaded
                          </Badge>
                        )}

                        {!isApproved && (
                          <label className="inline-flex h-8 cursor-pointer items-center rounded-md bg-[#5B9BD5] px-3 text-xs font-medium text-white hover:bg-[#4a8ac4]">
                            <Upload className="mr-1 h-3.5 w-3.5" />
                            {doc.file
                              ? "Change File"
                              : doc.uploadedUrl
                                ? "Replace File"
                                : "Choose File"}
                            <input
                              type="file"
                              className="hidden"
                              accept={(doc.acceptedFormatsList?.length
                                ? doc.acceptedFormatsList
                                : (doc.acceptedFormats?.split(",") ?? [])
                              )
                                .map(
                                  (format) =>
                                    `.${format.trim().replace(/^\./, "")}`,
                                )
                                .join(",")}
                              onChange={(event) => {
                                selectMainDocumentFile(
                                  doc.id,
                                  event.target.files?.[0],
                                );
                                event.target.value = "";
                              }}
                            />
                          </label>
                        )}
                        {doc.file && (
                          <span
                            className="max-w-48 truncate text-xs text-green-700"
                            title={doc.file.name}
                          >
                            {doc.file.name}
                          </span>
                        )}

                        {doc.history && doc.history.length > 0 && (
                          <Button
                            size="sm"
                            variant="outline"
                            onClick={() => toggleDocHistory(doc.id)}
                            className="text-sm border-gray-300 hover:bg-gray-50 rounded-xl flex items-center gap-1"
                          >
                            <History className="w-3 h-3" />
                            History ({doc.history.length})
                            {expandedDocHistory[doc.id] ? (
                              <ChevronUp className="w-3 h-3" />
                            ) : (
                              <ChevronDown className="w-3 h-3" />
                            )}
                          </Button>
                        )}

                        {/* Upload And Reject Doc Button - Always visible */}
                        {/* {doc.status !== 'REJECTED' && doc.uploadedUrl ? (<Button
                          size="sm"
                          variant="ghost"
                          onClick={() => handleDeleteDocument(doc.id)}
                          className="text-red-600 hover:text-red-700 hover:bg-red-50 rounded-xl"
                        >
                          {canDelete && (
                            <Trash2 className="w-4 h-4" />
                          )}
                        </Button>) : */}
                        {doc.status === "REJECTED" && (
                          <Button
                            size="sm"
                            onClick={() => {
                              setRejectedDoc({ ...doc, isPartner: false });
                              setShowUploadDialog(true);
                            }}
                            style={{ backgroundColor: "#5B9BD5" }}
                            className="text-white text-xs"
                          >
                            <Upload className="w-3.5 h-3.5 mr-1" />
                            {doc.status === "REJECTED" ? "Re-upload" : "Upload"}
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Document History - Super Admin Only */}
                  {doc.versions &&
                    doc.versions.length > 0 &&
                    expandedDocHistory[doc.id] && (
                      <div className="bg-gradient-to-r from-blue-50 to-white border-t border-gray-200 p-4">
                        <h4
                          className="text-sm mb-3"
                          style={{ color: "#5B9BD5" }}
                        >
                          📋 Document Upload History ({doc.versions.length}{" "}
                          versions)
                        </h4>

                        <div className="space-y-4">
                          {doc.versions.map((version, versionIndex) => (
                            <div key={versionIndex}>
                              {/* <div className="text-xs font-semibold text-gray-700 mb-2">
                                Version {version.id}
                              </div> */}

                              {version.histories?.map((hist, histIndex) => (
                                <div
                                  key={hist.id || histIndex}
                                  className={`p-3 rounded-lg border mb-2 ${
                                    hist.historyStatus?.toLowerCase() ===
                                    "approved"
                                      ? "bg-green-50 border-green-200"
                                      : hist.historyStatus?.toLowerCase() ===
                                          "rejected"
                                        ? "bg-red-50 border-red-200"
                                        : "bg-gray-50 border-gray-200"
                                  }`}
                                >
                                  <div className="flex items-start justify-between gap-3">
                                    <div className="flex-1">
                                      <div className="flex items-center gap-2 mb-1">
                                        <Badge
                                          className={`text-xs ${
                                            hist.historyStatus?.toLowerCase() ===
                                            "approved"
                                              ? "bg-green-100 text-green-700 border-green-300"
                                              : hist.historyStatus?.toLowerCase() ===
                                                  "rejected"
                                                ? "bg-red-100 text-red-700 border-red-300"
                                                : "bg-gray-100 text-gray-700 border-gray-300"
                                          }`}
                                        >
                                          {hist.historyStatus
                                            ? hist.historyStatus.toUpperCase()
                                            : "PENDING"}
                                        </Badge>

                                        {hist.actionAt && (
                                          <span className="text-xs text-gray-600">
                                            {
                                              formatUploadedDateTime(
                                                hist.actionAt,
                                              ).date
                                            }{" "}
                                            at{" "}
                                            {
                                              formatUploadedDateTime(
                                                hist.actionAt,
                                              ).time
                                            }
                                          </span>
                                        )}
                                      </div>

                                      {hist.remarks && (
                                        <p className="text-xs text-gray-700 mt-1">
                                          <span className="text-gray-900">
                                            Remarks:
                                          </span>{" "}
                                          {hist.remarks}
                                        </p>
                                      )}
                                    </div>

                                    {/* ✅ View file of that specific version */}
                                    <button
                                      className="hover:bg-gray-100 rounded-lg p-1 transition-colors flex-shrink-0"
                                      style={{ color: "#5B9BD5" }}
                                      onClick={() => {
                                        if (!version.filePath) return;
                                        const fullUrl = getFileViewUrl(
                                          version.filePath,
                                        );
                                        window.open(fullUrl, "_blank");
                                      }}
                                    >
                                      <Eye className="w-4 h-4 cursor-pointer" />
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* AREA OF OPERATIONS */}
        <Card className="border-[#5B9BD5]/20 bg-white shadow-lg">
          <CardHeader>
            <div className="flex items-center gap-2">
              <MapPin className="w-5 h-5" style={{ color: "#5B9BD5" }} />
              <CardTitle className="text-gray-900">
                Area of Operations
              </CardTitle>
            </div>
            <p className="text-sm text-gray-600 mt-1">
              Update the locations where you conduct tour business
            </p>
          </CardHeader>
          <CardContent className="space-y-6">
            {formErrors.areasOfOperation && (
              <Alert
                variant="destructive"
                className="!border-red-500 !bg-red-50"
              >
                <AlertCircle className="h-4 w-4 !text-red-500" />
                <AlertDescription className="!text-red-600">
                  {formErrors.areasOfOperation}
                </AlertDescription>
              </Alert>
            )}
            <div className="space-y-4 rounded-lg border-2 border-dashed border-[#5B9BD5] bg-white p-4">
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
                <SearchableSelectFieldset
                  label="Country"
                  value={String(currentArea.countryId || "")}
                  options={countriesList.map((item) => ({
                    value: String(item.countryId),
                    label: item.countryName,
                  }))}
                  placeholder="Select country..."
                  searchPlaceholder="Search country..."
                  error={formErrors["new-area-country"]}
                  onChange={(value) => {
                    setCurrentArea((area) => ({
                      ...area,
                      countryId: value,
                      country: value,
                      cityId: "",
                      city: "",
                      otherCity: "",
                    }));
                    setFormErrors((errors) => ({
                      ...errors,
                      "new-area-country": "",
                      "new-area-city": "",
                    }));
                  }}
                />
                <SearchableSelectFieldset
                  label="City"
                  value={String(currentArea.cityId ?? "")}
                  options={[
                    ...(countriesList
                      .find(
                        (item) =>
                          String(item.countryId) ===
                          String(currentArea.countryId),
                      )
                      ?.cities.map((item) => ({
                        value: String(item.cityId),
                        label: item.cityName,
                      })) ?? []),
                    { value: "0", label: "Other City" },
                  ]}
                  placeholder="Select city..."
                  searchPlaceholder="Search city..."
                  error={formErrors["new-area-city"]}
                  disabled={!currentArea.countryId}
                  onChange={(value) => {
                    setCurrentArea((area) => ({
                      ...area,
                      cityId: value,
                      city: value,
                      otherCity: value === "0" ? area.otherCity : "",
                    }));
                    setFormErrors((errors) => ({
                      ...errors,
                      "new-area-city": "",
                    }));
                  }}
                />
                {String(currentArea.cityId) === "0" && (
                  <div className="space-y-1">
                    <InputFieldset
                      label="Other City"
                      required
                      value={currentArea.otherCity}
                      placeholder="Enter city name"
                      onChange={(event) => {
                        setCurrentArea((area) => ({
                          ...area,
                          otherCity: event.target.value,
                        }));
                        setFormErrors((errors) => ({
                          ...errors,
                          "new-area-city": "",
                        }));
                      }}
                    />
                  </div>
                )}
                <div
                  className={
                    String(currentArea.cityId) === "0" ? "" : "lg:col-span-2"
                  }
                >
                  <InputFieldset
                    label="Address"
                    required
                    value={currentArea.address}
                    placeholder="Enter complete address"
                    onChange={(event) => {
                      setCurrentArea((area) => ({
                        ...area,
                        address: event.target.value,
                      }));
                      setFormErrors((errors) => ({
                        ...errors,
                        "new-area-address": "",
                      }));
                    }}
                    className={
                      formErrors["new-area-address"] ? "border-red-500" : ""
                    }
                  />
                  {formErrors["new-area-address"] && (
                    <p className="text-xs text-red-600">
                      {formErrors["new-area-address"]}
                    </p>
                  )}
                </div>
                <div>
                  <InputFieldset
                    label="Contact Number"
                    required
                    value={currentArea.contactNumber}
                    placeholder="Include country code eg. +91XXXXXXXXXX"
                    onChange={(event) => {
                      const value = validatePhoneNumberInput(
                        event.target.value,
                      );
                      setCurrentArea((area) => ({
                        ...area,
                        contactNumber: value,
                      }));
                      setFormErrors((errors) => ({
                        ...errors,
                        "new-area-contact": "",
                      }));
                    }}
                    className={
                      formErrors["new-area-contact"] ? "border-red-500" : ""
                    }
                  />
                  {formErrors["new-area-contact"] && (
                    <p className="text-xs text-red-600">
                      {formErrors["new-area-contact"]}
                    </p>
                  )}
                </div>
              </div>
              <div className="flex justify-end">
                <Button
                  type="button"
                  onClick={handleAddArea}
                  disabled={isAddingArea}
                  className="bg-[#5B9BD5] text-white hover:bg-[#4A8AC4]"
                >
                  {isAddingArea ? (
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  ) : (
                    <Plus className="mr-2 h-4 w-4" />
                  )}
                  {isAddingArea ? "Adding..." : "Add Area"}
                </Button>
              </div>
            </div>

            {/* Display added areas */}
            {areasOfOperation.length > 0 && (
              <div className="space-y-3">
                <div className="space-y-2">
                  {areasOfOperation.map((area, index) => {
                    const areaCountry = countriesList.find(
                      (c) => String(c.countryId) === String(area.countryId),
                    );
                    const areaCity = areaCountry?.cities.find(
                      (c) => String(c.cityId) === String(area.cityId),
                    );
                    return (
                      <div
                        key={area.id || index}
                        className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-4 rounded-lg border-2 border-gray-200 bg-white border border-gray-200 hover:border-[#5B9BD5]/50 transition-colors gap-3"
                      >
                        <div className="flex-1 w-full space-y-3">
                          <div className="mb-1 flex items-center justify-between gap-3">
                            <div className="flex items-center gap-2">
                              <span
                                className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full text-xs text-white"
                                style={{ backgroundColor: "#5B9BD5" }}
                              >
                                {index + 1}
                              </span>
                              <p className="break-words text-gray-900">
                                {areaCountry?.countryName ||
                                  area.areaCountryName}{" "}
                                -{" "}
                                {String(area.cityId) === "0"
                                  ? area.otherCity || "Other City"
                                  : areaCity?.cityName || "City not found"}
                              </p>
                            </div>
                            {canDelete && (
                              <Button
                                type="button"
                                size="sm"
                                variant="outline"
                                onClick={() => handleRemoveArea(area)}
                                className="rounded-xl border-red-200 text-red-600 hover:bg-red-50 hover:text-red-700"
                              >
                                <Trash2 className="h-4 w-4" />
                              </Button>
                            )}
                          </div>
                          <p className="text-sm text-gray-600 ml-0 sm:ml-8 break-words">
                            {area.address} • {area.contactNumber}
                          </p>
                          {!isApproved && (
                            <div className="grid grid-cols-1 gap-3 pt-2 md:grid-cols-2 lg:grid-cols-4">
                              <SearchableSelectFieldset
                                label="Country"
                                value={String(area.countryId ?? "")}
                                options={countriesList.map((item) => ({
                                  value: String(item.countryId),
                                  label: item.countryName,
                                }))}
                                placeholder="Select country..."
                                searchPlaceholder="Search country..."
                                error={formErrors[`area-${index}-country`]}
                                onChange={(value) =>
                                  setAreasOfOperation((items) =>
                                    items.map((item, itemIndex) =>
                                      itemIndex === index
                                        ? {
                                            ...item,
                                            countryId: value,
                                            cityId: "",
                                            otherCity: "",
                                          }
                                        : item,
                                    ),
                                  )
                                }
                              />
                              <SearchableSelectFieldset
                                label="City"
                                value={String(area.cityId ?? "")}
                                options={[
                                  ...(countriesList
                                    .find(
                                      (item) =>
                                        String(item.countryId) ===
                                        String(area.countryId),
                                    )
                                    ?.cities.map((item) => ({
                                      value: String(item.cityId),
                                      label: item.cityName,
                                    })) || []),
                                  {
                                    value: "0",
                                    label: area.otherCity || "Other City",
                                  },
                                ]}
                                placeholder="Select city..."
                                searchPlaceholder="Search city..."
                                error={formErrors[`area-${index}-city`]}
                                onChange={(value) =>
                                  setAreasOfOperation((items) =>
                                    items.map((item, itemIndex) =>
                                      itemIndex === index
                                        ? {
                                            ...item,
                                            cityId: value,
                                            otherCity:
                                              value === "0"
                                                ? item.otherCity
                                                : "",
                                          }
                                        : item,
                                    ),
                                  )
                                }
                              />
                              {String(area.cityId) === "0" && (
                                <div>
                                  <InputFieldset
                                    label="Other City"
                                    required
                                    value={area.otherCity || ""}
                                    onChange={(event) =>
                                      setAreasOfOperation((items) =>
                                        items.map((item, itemIndex) =>
                                          itemIndex === index
                                            ? {
                                                ...item,
                                                otherCity: event.target.value,
                                              }
                                            : item,
                                        ),
                                      )
                                    }
                                  />
                                </div>
                              )}
                              <div>
                                <InputFieldset
                                  label="Address"
                                  required
                                  value={area.address}
                                  onChange={(event) =>
                                    setAreasOfOperation((items) =>
                                      items.map((item, itemIndex) =>
                                        itemIndex === index
                                          ? {
                                              ...item,
                                              address: event.target.value,
                                            }
                                          : item,
                                      ),
                                    )
                                  }
                                  className={
                                    formErrors[`area-${index}-address`]
                                      ? "border-red-500"
                                      : ""
                                  }
                                />
                                {formErrors[`area-${index}-address`] && (
                                  <p className="text-xs text-red-600">
                                    {formErrors[`area-${index}-address`]}
                                  </p>
                                )}
                              </div>
                              <div>
                                <InputFieldset
                                  label="Contact Number"
                                  required
                                  value={area.contactNumber}
                                  onChange={(event) => {
                                    const value = validatePhoneNumberInput(
                                      event.target.value,
                                    );
                                    setAreasOfOperation((items) =>
                                      items.map((item, itemIndex) =>
                                        itemIndex === index
                                          ? {
                                              ...item,
                                              contactNumber: value,
                                            }
                                          : item,
                                      ),
                                    );
                                  }}
                                  className={
                                    formErrors[`area-${index}-contact`]
                                      ? "border-red-500"
                                      : ""
                                  }
                                />
                                {formErrors[`area-${index}-contact`] && (
                                  <p className="text-xs text-red-600">
                                    {formErrors[`area-${index}-contact`]}
                                  </p>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                        {/* {activeTab === 'pending' && (
                          <Button
                            type="button"
                            variant="ghost"
                            size="sm"
                            onClick={() => handleRemoveArea(area)}
                            className="text-red-600 hover:text-red-700 hover:bg-red-50 self-end sm:self-auto"
                          >
                            {canDelete && (
                              <X className="w-4 h-4" />
                            )}
                          </Button>
                        )} */}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </CardContent>
        </Card>

        {/* Delete area of operation confirmpopup*/}
        <ConfirmDialog
          open={isAreaDeleteOpen}
          onOpenChange={setIsAreaDeleteOpen}
          title="Delete Area"
          description="Do you really want to delete?"
          confirmText="Delete"
          loading={isDeleting}
          onConfirm={handleConfirmDeleteArea}
        >
          {/* <p className="text-sm text-gray-700">
            Document Name: {selectedDoc?.name}
          </p> */}
        </ConfirmDialog>

        {/* Member Details & Documents */}
        {/* {partners && partners.length > 0 && ( */}
        <Card className="border-[#5B9BD5]/20 bg-white shadow-lg">
          <CardHeader>
            <div className="flex justify-between items-center">
              <div>
                <div className="flex items-center gap-2">
                  <Users className="w-5 h-5" style={{ color: "#5B9BD5" }} />
                  <CardTitle className="text-gray-900">
                    Member Details & Documents
                  </CardTitle>
                </div>
                <p className="text-sm text-gray-600 mt-1">
                  Review and edit member information. All fields except ITS
                  Number are editable. (
                  {partners.filter((p) => !p?.isMainOperator).length}{" "}
                  {partners.filter((p) => !p?.isMainOperator).length === 1
                    ? "member"
                    : "members"}
                  )
                </p>
              </div>
              <div>
                {/* ADD PARTNER POPUP */}
                {/* {canAdd && selectedRegistration?.businessType && selectedRegistration?.businessType !== 'sole_proprietor' && ( */}
                <Button
                  type="button"
                  onClick={handleOpenPartnerDialog}
                  className="h-9 px-4 text-white rounded-lg shadow-sm flex items-center gap-2 bg-green-700"
                >
                  <Plus className="w-4 h-4" />
                  Add Member
                </Button>
                {/* )} */}
              </div>
            </div>

            {/* Alert for New Partners Added After Approval */}
            {/* {pendingPartnerApprovalCount > 0 && (
              <Alert className="mt-3 border-amber-400 bg-gradient-to-r from-amber-50 to-orange-50">
                <AlertCircle className="h-4 w-4 text-amber-600" />
                <AlertDescription className="text-sm text-amber-900 ml-2">
                  <strong className="font-semibold">
                    ⚠️ Attention Required:
                  </strong>{" "}
                  {pendingPartnerApprovalCount} new{" "}
                  {pendingPartnerApprovalCount === 1
                    ? "member has"
                    : "members have"}{" "}
                  been added after the initial approval and{" "}
                  {pendingPartnerApprovalCount === 1
                    ? "requires"
                    : "require"}{" "}
                  review. These members are highlighted in amber below.
                </AlertDescription>
              </Alert>
            )} */}
          </CardHeader>
          <CardContent className="space-y-6">
            {partners
              .filter((partner) => !partner.isMainOperator)
              .map((partner, index) => (
                <div
                  key={partner.id || index}
                  className={`p-6 rounded-lg border-2 bg-white space-y-4 ${
                    partner.approvedStatus === 0
                      ? "border-red-400 shadow-lg"
                      // : partner.addedAfterApproval
                      // ? "border-amber-400 shadow-lg"
                      : "border-gray-200"
                  }`}
                >
                  {/* Member Header */}
                  <div className="flex items-center justify-between pb-3 border-b border-gray-200">
                    <div className="flex items-center gap-3">
                      <span
                        className="flex items-center justify-center w-10 h-10 rounded-full text-white"
                        style={{ backgroundColor: "#5B9BD5" }}
                      >
                        {index + 1}
                      </span>
                      <div>
                        <h3 className="text-gray-900">Member {index + 1}</h3>
                        <p className="text-sm text-gray-600 font-mono">
                          ITS: {partner.itsNumber}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      {partner.approvedStatus === 0 && (
                        <TooltipProvider>
                          <Tooltip>
                            <TooltipTrigger asChild>
                              <span className="inline-flex h-9 w-9 cursor-help items-center justify-center rounded-full bg-amber-100 text-amber-600">
                                <TriangleAlert className="h-5 w-5" />
                              </span>
                            </TooltipTrigger>
                            <TooltipContent
                              side="left"
                              className="w-48 !whitespace-normal break-words text-left"
                            >
                              Approval is required for this member.
                            </TooltipContent>
                          </Tooltip>
                        </TooltipProvider>
                      )}
                      {canDelete && (
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => {
                            setPartnerToRemove(partner);
                            setIsPartnerRemoveDialogOpen(true);
                          }}
                          className="text-red-600 hover:text-red-700 hover:bg-red-50 border-red-200 rounded-xl"
                        >
                          <Trash2 className="w-4 h-4" />
                        </Button>
                      )}
                    </div>
                  </div>

                  {/* Editable Member Information */}
                  {
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                      <div className="space-y-2">
                        <InputFieldset
                          label="ITS Number"
                          id="partnerItsNumber"
                          value={partner?.itsNumber || "N/A"}
                          readOnly
                          disabled
                          tabIndex={-1}
                          className="!bg-gray-100 cursor-not-allowed font-mono [&_legend]:!bg-gray-100"
                        />
                      </div>

                      <div className="space-y-2">
                        <InputFieldset
                          label="Full Name"
                          required
                          id={`partner-${partner.id}-fullName`}
                          value={partner.fullName}
                          onChange={(e) => {
                            setPartners(
                              partners.map((p) =>
                                p.id === partner.id
                                  ? { ...p, fullName: e.target.value }
                                  : p,
                              ),
                            );
                            setFormErrors((errors) => ({
                              ...errors,
                              [`partner-${index}-name`]: "",
                            }));
                          }}
                          placeholder="Enter full name"
                          className={cn(
                            formErrors[`partner-${index}-name`] &&
                              "border-red-500",
                            isApproved &&
                              "!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100",
                          )}
                          disabled={isApproved}
                        />
                        {formErrors[`partner-${index}-name`] && (
                          <p className="text-xs text-red-600">
                            {formErrors[`partner-${index}-name`]}
                          </p>
                        )}
                      </div>

                      <div className="space-y-2">
                        <InputFieldset
                          label="Email"
                          required
                          id={`partner-${partner.id}-email`}
                          type="email"
                          value={partner.email}
                          onChange={(e) => {
                            setPartners(
                              partners.map((p) =>
                                p.id === partner.id
                                  ? { ...p, email: e.target.value }
                                  : p,
                              ),
                            );
                            setFormErrors((errors) => ({
                              ...errors,
                              [`partner-${index}-email`]: "",
                            }));
                          }}
                          placeholder="Enter email"
                          className={cn(
                            formErrors[`partner-${index}-email`] &&
                              "border-red-500",
                            isApproved &&
                              "!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100",
                          )}
                          disabled={isApproved}
                        />
                        {formErrors[`partner-${index}-email`] && (
                          <p className="text-xs text-red-600">
                            {formErrors[`partner-${index}-email`]}
                          </p>
                        )}
                      </div>

                      <div className="space-y-2">
                        <InputFieldset
                          label="Mobile Number"
                          required
                          id={`partner-${partner.id}-mobile`}
                          value={partner.mobileNumber}
                          onChange={(e) => {
                            const value = validatePhoneNumberInput(
                              e.target.value,
                            );
                            setPartners(
                              partners.map((p) =>
                                p.id === partner.id
                                  ? { ...p, mobileNumber: value }
                                  : p,
                              ),
                            );
                          }}
                          placeholder="+XXX-XXX-XXXXXXX"
                          className={cn(
                            formErrors[`partner-${index}-mobile`] &&
                              "border-red-500",
                            isApproved &&
                              "!bg-gray-100 cursor-not-allowed [&_legend]:!bg-gray-100",
                          )}
                          disabled={isApproved}
                        />
                        {formErrors[`partner-${index}-mobile`] && (
                          <p className="text-xs text-red-600">
                            {formErrors[`partner-${index}-mobile`]}
                          </p>
                        )}
                      </div>
                    </div>
                  }

                  {/* Member Role Radio Buttons */}
                  <div className="flex items-center gap-6 pt-3 border-t border-gray-200">
                    <Label className="text-gray-900">
                      Member Type <span className="text-red-500">*</span>
                    </Label>
                    <div className="flex items-center space-x-4">
                      <div className="flex items-center space-x-2 cursor-not-allowed">
                        <input
                          type="radio"
                          id={`partner-${partner.id}-isPartner`}
                          name={`partner-${partner.id}-role`}
                          checked={partner.isPartner}
                          onChange={() =>
                            setPartners((items) =>
                              items.map((item) =>
                                item.id === partner.id
                                  ? {
                                      ...item,
                                      role: "partner",
                                      isPartner: true,
                                      isOfficeStaff: false,
                                      documents: mergeDocumentRequirements(
                                        documentRequirements,
                                        item.documents ?? [],
                                      ),
                                    }
                                  : item,
                              ),
                            )
                          }
                          disabled={isApproved}
                          className="w-4 h-4 text-[#5B9BD5] focus:ring-[#5B9BD5]"
                        />
                        <label
                          htmlFor={`partner-${partner.id}-isPartner`}
                          className="text-sm text-gray-900 cursor-pointer"
                        >
                          Is Partner
                        </label>
                      </div>

                      <div className="flex items-center space-x-2 cursor-not-allowed">
                        <input
                          type="radio"
                          id={`partner-${partner.id}-isOfficeStaff`}
                          name={`partner-${partner.id}-role`}
                          checked={partner.isOfficeStaff}
                          onChange={() =>
                            setPartners((items) =>
                              items.map((item) =>
                                item.id === partner.id
                                  ? {
                                      ...item,
                                      role: "office_staff",
                                      isPartner: false,
                                      isOfficeStaff: true,
                                    }
                                  : item,
                              ),
                            )
                          }
                          disabled={isApproved}
                          className="w-4 h-4 text-[#5B9BD5] focus:ring-[#5B9BD5]"
                        />
                        <label
                          htmlFor={`partner-${partner.id}-isOfficeStaff`}
                          className="text-sm text-gray-900 cursor-pointer"
                        >
                          Office Staff
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* Additional Member Options */}
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 pt-3 border-t border-gray-200 cursor-not-allowed">
                    <div className="flex items-center space-x-2">
                      <Checkbox
                        id={`partner-${partner.id}-loginRequired`}
                        checked={partner.loginRequired}
                        onCheckedChange={(checked) =>
                          setPartners((items) =>
                            items.map((item) =>
                              item.id === partner.id
                                ? { ...item, loginRequired: !!checked }
                                : item,
                            ),
                          )
                        }
                        disabled={isApproved}
                      />
                      <label
                        htmlFor={`partner-${partner.id}-loginRequired`}
                        className="text-sm text-gray-900 cursor-pointer cursor-not-allowed"
                      >
                        Login Required
                      </label>
                    </div>

                    <div className="flex items-center space-x-2 cursor-not-allowed">
                      <Checkbox
                        id={`partner-${partner.id}-isAGL`}
                        checked={partner.isAuthorizedGroupLeader}
                        onCheckedChange={(checked) =>
                          setPartners((items) =>
                            items.map((item) =>
                              item.id === partner.id
                                ? {
                                    ...item,
                                    isAuthorizedGroupLeader: !!checked,
                                  }
                                : item,
                            ),
                          )
                        }
                        disabled={isApproved}
                      />
                      <label
                        htmlFor={`partner-${partner.id}-isAGL`}
                        className="text-sm text-gray-900 cursor-pointer cursor-not-allowed"
                      >
                        Authorized Group Leader
                      </label>
                    </div>
                  </div>

                  {/* Member Documents */}
                  {partner.isPartner && (
                    <div className="space-y-3 pt-3 border-t border-gray-200">
                      <h4 className="text-gray-900">Member Documents</h4>
                      {formErrors[`partner-${index}-documents`] && (
                        <p className="text-xs text-red-600">
                          {formErrors[`partner-${index}-documents`]}
                        </p>
                      )}
                      <div className="space-y-3">
                        {partner?.documents?.length > 0 &&
                          partner?.documents?.map((doc, docIndex) => {
                            return (
                              <div
                                key={doc.id}
                                className="border border-gray-200 rounded-lg overflow-hidden"
                              >
                                {/* Document Row */}
                                <div className="bg-white hover:bg-gray-50 transition-colors p-3">
                                  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                                    <span className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-100 text-gray-900 flex-shrink-0">
                                      {docIndex + 1}
                                    </span>
                                    <div className="flex-1 min-w-0">
                                      <p className="text-gray-900 text-sm break-words">
                                        {doc.name}
                                        {doc.isRequired && (
                                          <span className="text-red-500 ml-1">
                                            *
                                          </span>
                                        )}
                                      </p>
                                      <p className="text-xs text-red-400">
                                        {`Accepted format: ${doc.acceptedFormatsList?.join(", ") || doc.acceptedFormats || "Any"} (Max ${formatFileSizeFromKB(
                                          doc.maxFileSizeKB,
                                        )})`}
                                      </p>
                                    </div>
                                    <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
                                      {doc.status === "REJECTED" ? (
                                        <Badge className="bg-red-100 text-red-700 border-0 text-[10px] px-1.5 py-0.5">
                                          Rejected
                                        </Badge>
                                      ) : doc.uploadedUrl ? (
                                        <>
                                          <CheckCircle2 className="w-5 h-5 text-green-600" />
                                          <span className="text-sm text-green-700">
                                            uploaded
                                          </span>
                                          <button
                                            className="hover:bg-gray-100 rounded-lg p-1.5 transition-colors"
                                            style={{ color: "#5B9BD5" }}
                                          >
                                            <Eye
                                              className="w-4 h-4 cursor-pointer"
                                              onClick={() => {
                                                const fullUrl = getFileViewUrl(
                                                  doc.uploadedUrl,
                                                );
                                                window.open(fullUrl, "_blank");
                                              }}
                                            />
                                          </button>
                                        </>
                                      ) : (
                                        <Badge className="bg-gray-200 text-gray-700 border-0 text-[10px] px-1.5 py-0.5">
                                          Not Uploaded
                                        </Badge>
                                      )}

                                      {!isApproved && (
                                        <label className="inline-flex h-7 cursor-pointer items-center rounded-md bg-[#5B9BD5] px-2.5 text-xs font-medium text-white hover:bg-[#4a8ac4]">
                                          <Upload className="mr-1 h-3.5 w-3.5" />
                                          {doc.file
                                            ? "Change File"
                                            : doc.uploadedUrl
                                              ? "Replace File"
                                              : "Choose File"}
                                          <input
                                            type="file"
                                            className="hidden"
                                            accept={(doc.acceptedFormatsList
                                              ?.length
                                              ? doc.acceptedFormatsList
                                              : (doc.acceptedFormats?.split(
                                                  ",",
                                                ) ?? [])
                                            )
                                              .map(
                                                (format) =>
                                                  `.${format.trim().replace(/^\./, "")}`,
                                              )
                                              .join(",")}
                                            onChange={(event) => {
                                              selectPartnerDocumentFile(
                                                partner.id,
                                                doc.id,
                                                event.target.files?.[0],
                                              );
                                              event.target.value = "";
                                            }}
                                          />
                                        </label>
                                      )}
                                      {doc.file && (
                                        <span
                                          className="max-w-40 truncate text-xs text-green-700"
                                          title={doc.file.name}
                                        >
                                          {doc.file.name}
                                        </span>
                                      )}

                                      {doc?.history &&
                                        doc.history.length > 0 && (
                                          <Button
                                            size="sm"
                                            variant="outline"
                                            onClick={() =>
                                              togglePartnerDocHistory(
                                                `${partner.id}-${doc.id}`,
                                              )
                                            }
                                            className="text-xs border-gray-300 hover:bg-gray-50 rounded-lg flex items-center gap-1 h-7"
                                          >
                                            <History className="w-3 h-3" />
                                            History ({doc.history.length})
                                            {expandedPartnerDocHistory[
                                              `${partner.id}-${doc.id}`
                                            ] ? (
                                              <ChevronUp className="w-3 h-3" />
                                            ) : (
                                              <ChevronDown className="w-3 h-3" />
                                            )}
                                          </Button>
                                        )}

                                      {/* Upload and Reject Document Button - Always visible */}
                                      {/* {doc.status !== 'REJECTED' && doc.uploadedUrl ? (<Button
                                    size="sm"
                                    variant="ghost"
                                    onClick={() => handleDeleteDocument(doc.id)}
                                    className="text-red-600 hover:text-red-700 hover:bg-red-50 rounded-xl"
                                  >
                                    {canDelete && (
                                      <Trash2 className="w-4 h-4" />
                                    )}
                                  </Button>)} : */}
                                      {doc.status === "REJECTED" && (
                                        <Button
                                          size="sm"
                                          onClick={() => {
                                            setRejectedDoc({
                                              ...doc,
                                              isPartner: true,
                                              partnerid: partner.id,
                                            });
                                            setShowUploadDialog(true);
                                          }}
                                          style={{ backgroundColor: "#5B9BD5" }}
                                          className="text-white text-xs"
                                        >
                                          {canAdd && (
                                            <Upload className="w-3.5 h-3.5 mr-1" />
                                          )}
                                          {doc.status === "REJECTED"
                                            ? "Re-upload"
                                            : "Upload"}
                                        </Button>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {/* Document History - Super Admin Only */}
                                {doc?.history &&
                                  doc.history.length > 0 &&
                                  expandedPartnerDocHistory[
                                    `${partner.id}-${doc.id}`
                                  ] && (
                                    <div className="bg-gradient-to-r from-blue-50 to-white border-t border-gray-200 p-3">
                                      <h5
                                        className="text-xs mb-2"
                                        style={{ color: "#5B9BD5" }}
                                      >
                                        📋 Upload History ({doc.history.length}{" "}
                                        versions)
                                      </h5>
                                      <div className="space-y-2">
                                        {doc.history.map((hist, index) => (
                                          <div
                                            key={hist.id || index}
                                            className={`p-2 rounded-lg border ${
                                              hist.historyStatus.toLowerCase() ===
                                              "approved"
                                                ? "bg-green-50 border-green-200"
                                                : hist.historyStatus.toLowerCase() ===
                                                    "rejected"
                                                  ? "bg-red-50 border-red-200"
                                                  : "bg-gray-50 border-gray-200"
                                            }`}
                                          >
                                            <div className="flex flex-col sm:flex-row items-start sm:items-start justify-between gap-2">
                                              <div className="flex-1 w-full sm:w-auto">
                                                <div className="flex flex-wrap items-center gap-2 mb-1">
                                                  <Badge
                                                    className={`text-xs ${
                                                      hist.historyStatus.toLowerCase() ===
                                                      "approved"
                                                        ? "bg-green-100 text-green-700 border-green-300"
                                                        : hist.historyStatus.toLowerCase() ===
                                                            "rejected"
                                                          ? "bg-red-100 text-red-700 border-red-300"
                                                          : "bg-gray-100 text-gray-700 border-gray-300"
                                                    }`}
                                                  >
                                                    {hist.historyStatus.toUpperCase()}
                                                  </Badge>
                                                  {hist.actionAt && (
                                                    <span className="text-xs text-gray-600">
                                                      Uploaded:{" "}
                                                      {
                                                        formatUploadedDateTime(
                                                          hist.actionAt,
                                                        ).date
                                                      }{" "}
                                                      at{" "}
                                                      {
                                                        formatUploadedDateTime(
                                                          hist.actionAt,
                                                        ).time
                                                      }
                                                    </span>
                                                  )}
                                                </div>
                                                {hist.reviewedBy && (
                                                  <span className="text-xs text-gray-600 block mb-1">
                                                    Reviewed by{" "}
                                                    {hist.reviewedBy} on{" "}
                                                    {hist.reviewedDate} at{" "}
                                                    {hist.reviewedTime}
                                                  </span>
                                                )}
                                                {hist.remarks && (
                                                  <p className="text-xs text-gray-700 break-words">
                                                    <span className="text-gray-900">
                                                      Remarks:
                                                    </span>{" "}
                                                    {hist.remarks}
                                                  </p>
                                                )}
                                              </div>
                                              <button
                                                className="hover:bg-gray-100 rounded-lg p-1 transition-colors flex-shrink-0"
                                                style={{ color: "#5B9BD5" }}
                                              >
                                                <Eye
                                                  className="w-3.5 h-3.5 cursor-pointer"
                                                  onClick={() => {
                                                    if (!hist.filePath) return;

                                                    const fullUrl =
                                                      getFileViewUrl(
                                                        hist.filePath,
                                                      );
                                                    window.open(
                                                      fullUrl,
                                                      "_blank",
                                                    );
                                                  }}
                                                />
                                              </button>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  )}
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  )}
                </div>
              ))}
          </CardContent>
        </Card>

        {/* Action Buttons - Only for Pending */}
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-end gap-3 sm:gap-4 pt-4">
          {/* Reject Section */}
          <div className="hidden space-y-2">
            <SelectFieldset label="Rejection Reason (Required if rejecting)">
              <TextareaUI
                id="rejectReason"
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                placeholder="Please provide detailed reason for rejection..."
                className="min-h-[100px] bg-white border-gray-300 rounded-xl resize-none"
              />
            </SelectFieldset>
          </div>
        </div>

        <Card className="hidden border-[#5B9BD5]/20 bg-white shadow-lg">
          <CardContent className="pt-6">
            <div className="z-10 flex flex-col gap-3 border-t border-sky-100 bg-white/95 px-4 py-3 shadow-[0_-4px_12px_rgba(15,23,42,0.08)] backdrop-blur sm:flex-row sm:items-center sm:justify-between rounded-xl">
              {Object.keys(formErrors).length > 0 && (
                <p className="text-left text-sm text-red-600">
                  Please correct all validation errors before updating.
                </p>
              )}
              <Button
                type="button"
                onClick={handleUpdateRegistration}
                disabled={isUpdating}
                className="min-w-40 bg-[#5B9BD5] text-white hover:bg-[#4A8AC4] sm:ml-auto"
              >
                {isUpdating ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    Updating...
                  </>
                ) : (
                  "Update Registration"
                )}
              </Button>
            </div>

            <div className="space-y-4">
              {/* Reject Section */}
              <div className="space-y-2">
                <SelectFieldset label="Rejection Reason (Required if rejecting)">
                  <TextareaUI
                    id="rejectReason"
                    value={rejectReason}
                    onChange={(e) => setRejectReason(e.target.value)}
                    placeholder="Please provide detailed reason for rejection..."
                    className="min-h-[100px] bg-white border-gray-300 rounded-xl resize-none"
                  />
                </SelectFieldset>
              </div>

              {/* Action Buttons */}

              <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-end gap-3 sm:gap-4 pt-4">
                {canDelete && (
                  <Button
                    disabled={isUploading}
                    onClick={handleReject}
                    variant="outline"
                    className="px-8 border-2 border-red-500 text-red-600 hover:bg-red-50 rounded-xl w-full sm:w-auto"
                  >
                    <XCircle className="w-4 h-4 mr-2" />

                    {isUploading ? (
                      <>
                        <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                        loading...
                      </>
                    ) : (
                      <>Reject Application</>
                    )}
                  </Button>
                )}
                {canApprove && (
                  <Button
                    disabled={isUploading}
                    onClick={handleApproved}
                    className="px-12 text-white shadow-lg hover:opacity-90 transition-opacity rounded-xl w-full sm:w-auto"
                    style={{ backgroundColor: "#5B9BD5" }}
                  >
                    <CheckCircle2 className="w-4 h-4 mr-2" />
                    {isUploading ? (
                      <>
                        <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                        loading...
                      </>
                    ) : (
                      <>Approve Registration</>
                    )}
                  </Button>
                )}
              </div>
            </div>
          </CardContent>
        </Card>

        {isRejected && (
          <Card className="border-[#5B9BD5]/20 bg-white shadow-lg">
            <CardContent className="pt-6">
              <div className="z-10 flex flex-col sm:flex-row sm:items-center sm:justify-between rounded-xl">
                {Object.keys(formErrors).length > 0 && (
                  <p className="text-left text-sm text-red-600">
                    Please correct all validation errors before updating.
                  </p>
                )}
                <Button
                  type="button"
                  onClick={handleUpdateRegistration}
                  disabled={isUpdating}
                  className="min-w-40 bg-[#5B9BD5] text-white hover:bg-[#4A8AC4] sm:ml-auto"
                >
                  {isUpdating ? (
                    <>
                      <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                      Updating...
                    </>
                  ) : (
                    "Update Registration"
                  )}
                </Button>
              </div>
            </CardContent>
          </Card>
        )}

        {/* Rejection Reason Display - Only for Rejected */}
        {activeTab === "rejected" && selectedRegistration?.rejectedReason && (
          <Alert className="border-red-200 bg-red-50">
            <AlertCircle className="w-4 h-4 text-red-600" />
            <AlertDescription className="text-red-800">
              <strong>Rejection Reason:</strong>{" "}
              {selectedRegistration.rejectedReason}
            </AlertDescription>
          </Alert>
        )}

        {/* Delete Document Confirmation Dialog */}
        {/* <Dialog open={isDeleteDialogOpen} onOpenChange={setIsDeleteDialogOpen}>
          <DialogContent className="sm:max-w-[500px]">
            <DialogHeader>
              <DialogTitle style={{ color: '#5B9BD5' }}>Remove Document</DialogTitle>
              <DialogDescription>
                Please provide a reason for removing this document. The applicant will be notified to upload a revised document.
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4 py-4">
              <div className="space-y-2">
                <Label htmlFor="deleteRemark" className="text-gray-900">
                  Reason for Document Revision <span className="text-red-500">*</span>
                </Label>
                <Textarea
                  id="deleteRemark"
                  value={deleteRemark}
                  onChange={(e) => setDeleteRemark(e.target.value)}
                  placeholder="e.g., Document is not clear, incorrect document uploaded, signature missing..."
                  className="min-h-[120px] bg-white border-gray-300 rounded-xl resize-none"
                />
              </div>
            </div>
            <DialogFooter>
              <Button
                variant="outline"
                onClick={() => {
                  setIsDeleteDialogOpen(false);
                  setDocumentToDelete(null);
                  setDeleteRemark('');
                }}
                className="rounded-xl"
              >
                Cancel
              </Button>
              <Button
                onClick={confirmDeleteDocument}
                disabled={isUploading}
                style={{ backgroundColor: "#5B9BD5" }}
                className="text-white rounded-xl"
              >
                {isUploading ? (
                  <>
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                    loading...
                  </>
                ) : (
                  <>
                    <Trash2 className="w-4 h-4 mr-2" />
                    Remove Document
                  </>
                )}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog> */}

        {/* REMOVE PARTNER CONFIRMATION DIALOG COMPONENT */}
        <ConfirmDialog
          open={isPartnerRemoveDialogOpen}
          onOpenChange={setIsPartnerRemoveDialogOpen}
          title="Remove member"
          description="Are you sure you want to remove this member from the registration?"
          confirmText="Remove"
          cancelText="Cancel"
          loading={isDeleting}
          onConfirm={handleConfirmRemovePartner}
        >
          {/* children render inside box */}
          {partnerToRemove && (
            <div className="py-2">
              <div className="p-4 rounded-lg border-2 border-gray-200 bg-gray-50 space-y-2">
                <div className="flex items-center gap-2">
                  <User className="w-4 h-4 text-gray-600" />
                  <p className="text-gray-900">{partnerToRemove.fullName}</p>
                </div>

                <p className="text-sm text-gray-600">
                  ITS Number: {partnerToRemove.itsNumber}
                </p>

                <p className="text-sm text-gray-600">
                  Email: {partnerToRemove.email}
                </p>
              </div>
            </div>
          )}
          {/* children render inside box */}
        </ConfirmDialog>
      </div>

      {/* ADD PARTNER POPUP  */}
      {isPartnerDialogOpen && (
        <AddNewPartnerPopup
          isPartnerDialogOpen={isPartnerDialogOpen}
          setIsPartnerDialogOpen={setIsPartnerDialogOpen}
          partnerFormData={partnerFormData}
          setPartnerFormData={setPartnerFormData}
          handlePartnerFileUpload={handlePartnerFileUpload}
          handleSavePartner={handleSavePartner}
          AddpartnerErrors={AddpartnerErrors}
          setAddPartnerErrors={setAddPartnerErrors}
          isSoleProprietor={businessType === "sole_proprietor"}
          // selectedRegistration={selectedRegistration}
        />
      )}
      {/* ADD PARTNER POPUP */}

      {/*RE-UPLOAD NEW DOCUMENT START POPUP*/}
      {showUploadDialog && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <Card className="bg-white shadow-lg rounded-2xl w-[500px]">
            <CardContent className="p-6">
              <h2 className="text-lg font-semibold text-gray-900 mb-4">
                Upload Documents
              </h2>
              <div className="space-y-4">
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                  <Upload className="w-8 h-8 text-gray-400 mx-auto mb-3" />
                  <Input
                    ref={fileInputRef}
                    type="file"
                    // multiple
                    accept=".pdf,.jpg,.jpeg,.png"
                    className="hidden"
                    onChange={(e) => {
                      const files = Array.from(e.target.files || []);
                      setReuploadFiles(files);
                    }}
                  />
                  <p className="text-sm text-gray-600 mt-2 mb-2">
                    {reUploadFiles.length > 0
                      ? `${reUploadFiles.length} file(s) selected`
                      : "No files selected"}
                  </p>
                  <div className="flex justify-center">
                    <Label htmlFor="batch-upload">
                      <Button
                        variant="outline"
                        onClick={() => fileInputRef.current?.click()}
                      >
                        Select Files
                      </Button>
                    </Label>
                  </div>
                </div>
                <div className="bg-amber-50 border-2 border-amber-200 rounded-lg p-3">
                  <p className="text-xs text-amber-800">Upload documents</p>
                </div>
              </div>
              <div className="flex items-center justify-end gap-3 mt-6">
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowUploadDialog(false);
                    setRejectedDoc(null);
                    setReuploadFiles([]);
                  }}
                  className="text-gray-900 hover:bg-gray-100"
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleNewConfirmUpload}
                  disabled={isUploading}
                  style={{ backgroundColor: "#5B9BD5" }}
                  className="text-white hover:opacity-90 px-6 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isUploading ? (
                    <>
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                      Uploading...
                    </>
                  ) : (
                    <>
                      <Upload className="w-4 h-4 mr-2" />
                      Confirm Upload
                    </>
                  )}
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
      {/* UPLOAD NEW DOCUMENT END */}
    </>
  );
};
